document.addEventListener("DOMContentLoaded", () => {
  // =============================================
  // 1. STATE MANAGEMENT
  // =============================================
  const state = {
    size: null,
    editedFront: null,
    editedBack: null,
    material: "Gloss",
    quantity: "QTY 10 FRONT ONLY",
    customizeBack: false,
    sameDesignBack: false,
    extraForBack: 0,
    price: 0,
    front: {
      image: null,
      imageUrl: null,
      imageTransform: null,
      qrCode: "No",
      qrCodeLink: "",
      qrCodePlacement: "NONE",
      bagColor: "No Bag",
    },
    back: {
      image: null,
      imageUrl: null,
      imageTransform: null,
      bagColor: "No Bag",
    },
    currentBoard: 1,
  };

  let designer = null;

  // =============================================
  // 2. PRICE VARIANTS
  // =============================================
  const PRICE_VARIANTS = {
    size: [
      { value: '3 1/8 x 5 1/8 x 2" (3.5g)', price: 7.94 },
      { value: '4 x 6 x 2" (7g)', price: 9.95 },
      { value: '5 x 8 x 2 1/2" (14g)', price: 7.95 },
      { value: '6 x 9 x 3" (28g)', price: 7.95 },
    ],
    qrCode: [
      { value: "No", price: 0.0 },
      { value: "Yes", price: 10.0 },
    ],
    bagColor: [
      { value: "No Bag", price: 0.0 },
      { value: "Black Bag", price: 0.0 },
      { value: "White Bag", price: 0.0 },
      { value: "Chrome Bag", price: 8.0 },
    ],
    material: [
      { value: "Gloss", price: 0.0 },
      { value: "Matte", price: 5.0 },
      { value: "Holographic", price: 8.0 },
      { value: "Diamond Holographic", price: 10.0 },
    ],
    quantity: [
      { value: "3.5g QTY 10 NO BAGS STICKER ONLY", price: 0 },
      { value: "3.5g QTY 10 FRONT ONLY", price: 7.05 },
      { value: "3.5g QTY 10 FRONT AND BACK", price: 18.3 },
      { value: "3.5g QTY 25 NO BAGS", price: 12.05 },
      { value: "3.5g QTY 25 FRONT ONLY", price: 29.05 },
      { value: "3.5g QTY 25 FRONT AND BACK", price: 37.05 },
      { value: "3.5g QTY 50 NO BAGS", price: 32.05 },
      { value: "3.5g QTY 50 FRONT ONLY", price: 42.05 },
      { value: "3.5g QTY 50 FRONT AND BACK", price: 67.05 },
      { value: "3.5g QTY 100 NO BAGS", price: 54.05 },
      { value: "3.5g QTY 100 FRONT ONLY", price: 87.05 },
    ],
  };

  const NON_EDITABLE_EXTS = ["pdf", "ai", "eps", "tiff", "psd"];
  const COLOR_MAPPINGS = {
    "No Bag": "#000000",
    "Black Bag": "#000000",
    "White Bag": "#ffffff",
    "Chrome Bag": "linear-gradient(45deg, #ffffff, #d9d9d9, #ffffff)",
  };

  // =============================================
  // 3. HELPER FUNCTIONS
  // =============================================
  function show(el) {
    if (el) el.style.display = "";
  }
  function hide(el) {
    if (el) el.style.display = "none";
  }
  function animatePriceChange(targetElement, start, end, duration = 500) {
    let startTime = null;
    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const currentValue = start + (end - start) * progress;
      targetElement.textContent = currentValue.toFixed(2);
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function priceOf(groupKey, chosenValue) {
    if (!chosenValue) return 0;
    const list = PRICE_VARIANTS[groupKey] || [];
    const found = list.find((item) => item.value === chosenValue);
    return found ? found.price : 0;
  }
  function debounce(func, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  }
  function dataURLtoFile(dataurl, filename) {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }
  function isBoardCustomized(boardState) {
    return (
      boardState.image || boardState.imageUrl || boardState.qrCode === "Yes"
    );
  }
  function disableBodyScroll() {
    const scrollY = window.scrollY;
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.dataset.scrollY = scrollY;
  }
  function enableBodyScroll() {
    const scrollY = document.body.dataset.scrollY || 0;
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    window.scrollTo(0, parseInt(scrollY, 10));
    document.body.removeAttribute("data-scrollY");
  }
  function findScrollableParent(el) {
    while (el) {
      const style = window.getComputedStyle(el);
      const overflow = style.overflow || style.overflowY;
      if (overflow === "auto" || overflow === "scroll") {
        if (el.scrollHeight > el.clientHeight) {
          return el;
        }
      }
      el = el.parentElement;
    }
    return document.documentElement;
  }
  function blinkVariantElement(element) {
    if (!element) return;

    const hasVariantClass =
      element.classList.contains("variant-picked") ||
      element.classList.contains("artwork-box");
    const blinkClass = hasVariantClass
      ? "no-border-variant-blink"
      : "border-variant-blink";

    let blinkCount = 0;
    const maxBlinks = 4; // 3 on/off cycles
    const blinkInterval = 300; // milliseconds

    const intervalId = setInterval(() => {
      element.classList.toggle(blinkClass);
      blinkCount++;

      if (blinkCount >= maxBlinks) {
        clearInterval(intervalId);
        element.classList.remove(blinkClass); // Ensure it's removed after blinking
      }
    }, blinkInterval);
  }

  // =============================================
  // 4. SIZE SELECTION
  // =============================================
  function setupSizeSelection() {
    const sizeVariant = document.getElementById("size-variant");
    if (!sizeVariant) return;
    sizeVariant.addEventListener("click", (event) => {
      const selected = event.target.closest(".sticker-variant");
      if (!selected || !sizeVariant.contains(selected)) return;
      const list = selected.closest(".sticker-variants__list");
      if (!list) return;
      list.querySelectorAll(".sticker-variant").forEach((el) => {
        el.classList.toggle("active", el === selected);
      });
      const value = selected.dataset.size;
      state.size = value;
      document.getElementById("artwork-variant").style.display = "";
      recalcPrice();
      designer.updateCanvasSize();
    });
  }

  // =============================================
  // 5. IMAGE UPLOAD HANDLING
  // =============================================
  function bindUploadForBoard(board) {
    const suf = board === 1 ? "b1" : "b2";
    const fileInput = document.getElementById(`upload-file-image-${suf}`);
    const chooseBtn = document.getElementById(`choose-file-btn-image-${suf}`);
    const artbox = document.getElementById(`upload-artbox-image-${suf}`);
    const previewBox = document.getElementById(`preview-box-image-${suf}`);
    const previewImg = document.getElementById(`preview-image-image-${suf}`);
    const deleteBtn = document.getElementById(`delete-image-${suf}`);
    const errorMsg = document.getElementById(`upload-file-error-image-${suf}`);
    if (
      !fileInput ||
      !chooseBtn ||
      !artbox ||
      !previewBox ||
      !previewImg ||
      !deleteBtn ||
      !errorMsg
    )
      return;
    const freshChoose = chooseBtn.cloneNode(true);
    const freshInput = fileInput.cloneNode(true);
    chooseBtn.replaceWith(freshChoose);
    fileInput.replaceWith(freshInput);
    freshChoose.addEventListener("click", (e) => {
      e.preventDefault();
      freshInput.click();
    });
    freshInput.addEventListener("change", (e) => {
      const file = e.target.files?.[0];
      if (!file) return;
      const allowed = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/webp",
        "image/svg+xml",
      ];
      if (!allowed.includes(file.type)) {
        errorMsg.textContent = "Please upload .jpg, .jpeg, .png, .webp or .svg";
        errorMsg.classList.add("active");
        freshInput.value = "";
        return;
      }
      const reader = new FileReader();
      reader.onload = (ev) => {
        previewImg.src = ev.target.result;
        artbox.style.display = "none";
        previewBox.style.display = "block";
        errorMsg.classList.remove("active");
        designer.handleImageUpload({ target: { files: [file] } }, board);
        // If same design is checked and uploading to front, update back
        if (board === 1 && state.sameDesignBack) {
          state.back.imageUrl = ev.target.result;
          state.back.image = file;
          const backPreviewImg = document.getElementById("preview-image-image-b2");
          const backArtbox = document.getElementById("upload-artbox-image-b2");
          const backPreviewBox = document.getElementById("preview-box-image-b2");
          if (backPreviewImg) backPreviewImg.src = ev.target.result;
          if (backArtbox) backArtbox.style.display = "none";
          if (backPreviewBox) backPreviewBox.style.display = "block";
        }
      };
      reader.readAsDataURL(file);
    });
    deleteBtn.addEventListener("click", () => {
      freshInput.value = "";
      artbox.style.display = "block";
      previewBox.style.display = "none";
      previewImg.src = "";
      errorMsg.classList.remove("active");
      const bs = state[`${board === 1 ? "front" : "back"}`];
      bs.image = null;
      bs.imageUrl = null;
      bs.imageTransform = null;
      if (state.currentBoard === board && designer?.backgroundImage) {
        designer.canvas.remove(designer.backgroundImage);
        designer.backgroundImage = null;
        designer.canvas.renderAll();
        designer.updateFinishButtonState();
      }
      // If same design is checked and deleting from front, clear back
      if (board === 1 && state.sameDesignBack) {
        state.back.image = null;
        state.back.imageUrl = null;
        state.back.imageTransform = null;
        const backPreviewImg = document.getElementById("preview-image-image-b2");
        const backArtbox = document.getElementById("upload-artbox-image-b2");
        const backPreviewBox = document.getElementById("preview-box-image-b2");
        if (backPreviewImg) backPreviewImg.src = "";
        if (backArtbox) backArtbox.style.display = "block";
        if (backPreviewBox) backPreviewBox.style.display = "none";
      }
    });
  }

  // =============================================
  // 6. QR CODE SELECTION
  // =============================================
  function setupQRCodeSelection() {
    const qrCodeVariant = document.getElementById("qr-code-variant-b1");
    if (!qrCodeVariant) return;
    qrCodeVariant.addEventListener("click", (event) => {
      const selected = event.target.closest(".sticker-variant");
      if (!selected || !qrCodeVariant.contains(selected)) return;
      const list = selected.closest(".sticker-variants__list");
      if (!list) return;
      list.querySelectorAll(".sticker-variant").forEach((el) => {
        el.classList.toggle("active", el === selected);
      });
      const value = selected.dataset.qrCode;
      state.front.qrCode = value;
      const qrCodeLinkVariant = document.getElementById(
        "qr-code-link-variant-b1"
      );
      const qrCodePlacementVariant = document.getElementById(
        "qr-code-placement-variant-b1"
      );
      if (value === "Yes") {
        state.front.qrCodePlacement = "Top Left"; // Set default placement
        designer.addQRCode(); // Add QR code to canvas
        show(qrCodeLinkVariant);
        show(qrCodePlacementVariant);
        const placementList = document.querySelector(
          "#qr-code-placement-variant-b1 .sticker-variants__list"
        );
        if (placementList) {
          placementList.querySelectorAll(".sticker-variant").forEach((el) => {
            el.classList.toggle(
              "active",
              el.dataset.placement === state.front.qrCodePlacement
            );
          });
        }
        // If same design is checked, apply QR code to back
        if (state.sameDesignBack) {
          state.back.qrCode = value;
          state.back.qrCodePlacement = state.front.qrCodePlacement;
          state.back.qrCodeLink = state.front.qrCodeLink;
        }
      } else {
        hide(qrCodeLinkVariant);
        hide(qrCodePlacementVariant);
        state.front.qrCodeLink = "";
        state.front.qrCodePlacement = "NONE";
        if (designer.qrCodeImage) {
          designer.canvas.remove(designer.qrCodeImage);
          designer.qrCodeImage = null;
          designer.canvas.renderAll();
        }
        document.getElementById("qr-code-link-input-b1").value = "";
        document.getElementById("qr-code-link-char-count-b1").textContent =
          "1000 character(s) left";
        const placementList = document.querySelector(
          "#qr-code-placement-variant-b1 .sticker-variants__list"
        );
        if (placementList) {
          placementList.querySelectorAll(".sticker-variant").forEach((el) => {
            el.classList.toggle("active", el.dataset.placement === "NONE");
          });
        }
        // If same design is checked, clear QR code from back
        if (state.sameDesignBack) {
          state.back.qrCode = "No";
          state.back.qrCodeLink = "";
          state.back.qrCodePlacement = "NONE";
        }
      }
      recalcPrice();
      designer.updateFinishButtonState();
    });
  }

  // =============================================
  // 7. QR CODE LINK INPUT
  // =============================================
  function handleQRCodeLinkInput() {
    const input = document.getElementById("qr-code-link-input-b1");
    const counter = document.getElementById("qr-code-link-char-count-b1");
    const error = document.getElementById("qr-code-link-error-bar-b1");
    if (!input || !counter || !error) return;
    const MAX = 1000;
    const refresh = () => {
      if (input.value.length > MAX) {
        input.value = input.value.slice(0, MAX);
      }
      state.front.qrCodeLink = input.value;
      const remaining = MAX - input.value.length;
      counter.textContent = `${remaining} character(s) left`;
      if (input.value.trim()) {
        error.style.display = "none";
        input.parentElement.classList.add("variant-picked");
        designer.updateQRCode(input.value);
        // If same design is checked, update back QR code link
        if (state.sameDesignBack) {
          state.back.qrCodeLink = input.value;
        }
      } else {
        input.parentElement.classList.remove("variant-picked");
        error.style.display = "block";
        designer.updateQRCode("");
        // If same design is checked, clear back QR code link
        if (state.sameDesignBack) {
          state.back.qrCodeLink = "";
        }
      }
    };
    input.addEventListener("input", refresh);
    refresh();
  }

  // =============================================
  // 8. QR CODE PLACEMENT
  // =============================================
  function setupQRCodePlacement() {
    const placementVariant = document.getElementById(
      "qr-code-placement-variant-b1"
    );
    if (!placementVariant) return;
    placementVariant.addEventListener("click", (event) => {
      const selected = event.target.closest(".sticker-variant");
      if (!selected || !placementVariant.contains(selected)) return;
      const list = selected.closest(".sticker-variants__list");
      if (!list) return;
      list.querySelectorAll(".sticker-variant").forEach((el) => {
        el.classList.toggle("active", el === selected);
      });
      const value = selected.dataset.placement;
      state.front.qrCodePlacement = value;
      designer.updateQRCodePlacement(value);
      // If same design is checked, update back QR code placement
      if (state.sameDesignBack) {
        state.back.qrCodePlacement = value;
      }
    });
  }

  // =============================================
  // 9. BAG COLOR SELECTION
  // =============================================
  function setupBagColorSelection() {
    const bagColorVariant = document.getElementById("bag-color-variant-b1");
    if (!bagColorVariant) return;
    bagColorVariant.addEventListener("click", (event) => {
      const selected = event.target.closest(".sticker-variant");
      if (!selected || !bagColorVariant.contains(selected)) return;
      const list = selected.closest(".sticker-variants__list");
      if (!list) return;
      list.querySelectorAll(".sticker-variant").forEach((el) => {
        el.classList.toggle("active", el === selected);
      });
      const value = selected.dataset.color;
      state.front.bagColor = value;
      state.back.bagColor = value; // Apply same color to back
      designer.updateBagColor(value);
      recalcPrice();
    });
  }

  // =============================================
  // 10. MATERIAL AND QUANTITY SELECTION
  // =============================================
  function initDropdownDefaults() {
    document.querySelectorAll(".select-dropdown").forEach((dd) => {
      const preSel = dd.querySelector("li.selected");
      const header = dd.querySelector(".selected-text");
      if (preSel && header) {
        header.textContent = preSel.textContent;
        const stateKey = dd.dataset.stateKey;
        if (stateKey) {
          state[stateKey] = preSel.dataset.value;
        }
      }
    });
  }
  function dropdownClickHandler(evt) {
    const dropdown = evt.target.closest(".select-dropdown");
    if (!dropdown) {
      document
        .querySelectorAll(".dropdown-options")
        .forEach((list) => hide(list));
      return;
    }
    const list = dropdown.querySelector(".dropdown-options");
    const header = dropdown.querySelector(".selected-text");
    const stateKey = dropdown.dataset.stateKey;
    const optionEl = evt.target.closest("li[data-value]");
    document.querySelectorAll(".dropdown-options").forEach((other) => {
      if (other !== list) hide(other);
    });
    if (optionEl) {
      const value = optionEl.dataset.value;
      if (!value) return;
      list
        .querySelectorAll("li")
        .forEach((li) => li.classList.remove("selected"));
      optionEl.classList.add("selected");
      header.textContent = optionEl.textContent;
      dropdown.classList.add("variant-picked");
      if (stateKey) {
        state[stateKey] = value;
        // If same design is checked and quantity changes to include back, update state
        if (state.sameDesignBack && state.quantity.includes("FRONT AND BACK")) {
          state.customizeBack = true;
          state.back.image = state.front.image;
          state.back.imageUrl = state.front.imageUrl;
          state.back.imageTransform = state.front.imageTransform;
          state.back.qrCode = state.front.qrCode;
          state.back.qrCodeLink = state.front.qrCodeLink;
          state.back.qrCodePlacement = state.front.qrCodePlacement;
          state.back.bagColor = state.front.bagColor;
          const backPreviewImg = document.getElementById("preview-image-image-b2");
          const backArtbox = document.getElementById("upload-artbox-image-b2");
          const backPreviewBox = document.getElementById("preview-box-image-b2");
          if (state.front.imageUrl) {
            if (backPreviewImg) backPreviewImg.src = state.front.imageUrl;
            if (backArtbox) backArtbox.style.display = "none";
            if (backPreviewBox) backPreviewBox.style.display = "block";
          } else {
            if (backPreviewImg) backPreviewImg.src = "";
            if (backArtbox) backArtbox.style.display = "block";
            if (backPreviewBox) backPreviewBox.style.display = "none";
          }
        }
        recalcPrice();
      }
      hide(list);
      return;
    }
    list.style.display = list.style.display === "block" ? "none" : "block";
  }

  // =============================================
  // 11. PRICE CALCULATION
  // =============================================
  function recalcPrice() {
    let total = 0;
    total += priceOf("size", state.size) || 0;
    total += priceOf("qrCode", state.front.qrCode) || 0;
    total += priceOf("bagColor", state.front.bagColor) || 0;
    total += priceOf("material", state.material) || 0;
    total += priceOf("quantity", state.quantity) || 0;
    total += state.extraForBack;
    total = Math.round(total * 100) / 100;
    const priceEl = document.getElementById("pcs-final-price");
    if (priceEl) {
      const prevValue = parseFloat(priceEl.textContent) || 0;
      if (prevValue !== total) {
        animatePriceChange(priceEl, prevValue, total);
      }
    }
    state.price = total;
  }

  // =============================================
  // 12. DELETE PREVIEW
  // =============================================
  const deleteBannerImage = document.getElementById("delete-banner-image");
  deleteBannerImage.addEventListener("click", (e) => {
    e.preventDefault();
    resetSidebarVariants();
    if (designer) {
      designer.handleRemoveAllImproved();
    }
    state.currentBoard = 1;
    document.querySelectorAll(".board-tab").forEach((tab) => {
      const boardNum = parseInt(tab.dataset.board, 10);
      tab.classList.toggle("active", boardNum === 1);
    });
    document.getElementById("image-variant-b1").style.display = "";
    document.getElementById("variants-b1").style.display = "";
    document.getElementById("image-variant-b2").style.display = "none";
    document.getElementById("variants-b2").style.display = "none";
    const previewBox = document.getElementById("preview-box");
    const mainVariants = document.getElementById("main-variants");
    const uploadArtbox = document.getElementById("upload-artbox");
    const btnEditImage = document.getElementById("btnEditImage");
    if (previewBox) {
      previewBox.style.display = "none";
    }
    if (mainVariants) mainVariants.classList.remove("active");
    if (uploadArtbox) uploadArtbox.style.display = "block";
    if (btnEditImage) btnEditImage.style.display = "inline";
    const previewImage1 = document.getElementById("preview-image1");
    const previewImage2 = document.getElementById("preview-image2");
    if (previewImage1) previewImage1.src = "";
    if (previewImage2) previewImage2.src = "";
    const preview2Wrap = document.querySelector(".bag-preview2");
    if (preview2Wrap) preview2Wrap.style.display = "none";
    if (designer) {
      designer.renderBoardFromState(1);
    }
  });

  // =============================================
  // 13. RESET SIDEBAR VARIANTS
  // =============================================
  function resetSidebarVariants() {
    ["b1", "b2"].forEach((suf) => {
      const fileInput = document.getElementById(`upload-file-image-${suf}`);
      const artbox = document.getElementById(`upload-artbox-image-${suf}`);
      const previewBox = document.getElementById(`preview-box-image-${suf}`);
      const previewImg = document.getElementById(`preview-image-image-${suf}`);
      const errorMsg = document.getElementById(
        `upload-file-error-image-${suf}`
      );
      if (fileInput) fileInput.value = "";
      if (artbox) artbox.style.display = "block";
      if (previewBox) previewBox.style.display = "none";
      if (previewImg) previewImg.src = "";
      if (errorMsg) errorMsg.classList.remove("active");
    });
    state.front = {
      image: null,
      imageUrl: null,
      imageTransform: null,
      qrCode: "No",
      qrCodeLink: "",
      qrCodePlacement: "NONE",
      bagColor: "No Bag",
    };
    state.back = {
      image: null,
      imageUrl: null,
      imageTransform: null,
      bagColor: "No Bag",
    };
    state.editedFront = null;
    state.editedBack = null;
    state.customizeBack = false;
    state.sameDesignBack = false; // Reset same design checkbox
    const sameDesignCheckbox = document.getElementById("sameDesignBack");
    if (sameDesignCheckbox) sameDesignCheckbox.checked = false;
    const qrCodeList = document.querySelector(
      "#qr-code-variant-b1 .sticker-variants__list"
    );
    if (qrCodeList) {
      qrCodeList.querySelectorAll(".sticker-variant").forEach((el) => {
        el.classList.toggle("active", el.dataset.qrCode === "No");
      });
    }
    const qrCodeLinkInput = document.getElementById("qr-code-link-input-b1");
    if (qrCodeLinkInput) {
      qrCodeLinkInput.value = "";
      document.getElementById("qr-code-link-char-count-b1").textContent =
        "1000 character(s) left";
    }
    const placementList = document.querySelector(
      "#qr-code-placement-variant-b1 .sticker-variants__list"
    );
    if (placementList) {
      placementList.querySelectorAll(".sticker-variant").forEach((el) => {
        el.classList.toggle("active", el.dataset.placement === "NONE");
      });
    }
    const bagColorList = document.querySelector(
      "#bag-color-variant-b1 .sticker-variants__list"
    );
    if (bagColorList) {
      bagColorList.querySelectorAll(".sticker-variant").forEach((el) => {
        el.classList.toggle("active", el.dataset.color === "No Bag");
      });
    }
    document.querySelectorAll(".error-bar").forEach((el) => hide(el));
    document
      .querySelectorAll(".pcs-variant")
      .forEach((el) => el.classList.remove("has-error"));
    recalcPrice();
    if (designer) {
      designer.updateBagColor("No Bag");
      if (designer.qrCodeImage) {
        designer.canvas.remove(designer.qrCodeImage);
        designer.qrCodeImage = null;
        designer.canvas.renderAll();
      }
    }
  }
  
  // =============================================
  // 13. SAME DESIGN CHECKBOX
  // =============================================
  function setupSameDesignCheckbox() {
      const sameDesignCheckbox = document.getElementById("sameDesignBack");
      if (!sameDesignCheckbox) return;
      sameDesignCheckbox.addEventListener("change", (e) => {
          state.sameDesignBack = e.target.checked;
          const quantityDropdown = document.getElementById("quantity-select");
          // Update Back tab button state
          const backTabButtons = document.querySelectorAll('.board-tab[data-board="2"]');
          backTabButtons.forEach(btn => {
              btn.disabled = state.sameDesignBack;
              btn.style.opacity = state.sameDesignBack ? '0.5' : '1';
              btn.style.cursor = state.sameDesignBack ? 'not-allowed' : 'pointer';
          });
          if (state.sameDesignBack) {
              // Copy front design to back
              state.customizeBack = true;
              state.back.image = state.front.image;
              state.back.imageUrl = state.front.imageUrl;
              state.back.imageTransform = state.front.imageTransform;
              state.back.qrCode = state.front.qrCode;
              state.back.qrCodeLink = state.front.qrCodeLink;
              state.back.qrCodePlacement = state.front.qrCodePlacement;
              state.back.bagColor = state.front.bagColor;
              // Update back preview
              const backPreviewImg = document.getElementById("preview-image-image-b2");
              const backArtbox = document.getElementById("upload-artbox-image-b2");
              const backPreviewBox = document.getElementById("preview-box-image-b2");
              if (state.front.imageUrl) {
                  if (backPreviewImg) backPreviewImg.src = state.front.imageUrl;
                  if (backArtbox) backArtbox.style.display = "none";
                  if (backPreviewBox) backPreviewBox.style.display = "block";
              } else {
                  if (backPreviewImg) backPreviewImg.src = "";
                  if (backArtbox) backArtbox.style.display = "block";
                  if (backPreviewBox) backPreviewBox.style.display = "none";
              }
              // Update quantity to reflect back customization
              if (quantityDropdown && state.quantity.includes("FRONT ONLY")) {
                  const newQuantity = state.quantity.replace("FRONT ONLY", "FRONT AND BACK");
                  state.quantity = newQuantity;
                  const quantityHeader = quantityDropdown.querySelector(".selected-text");
                  const quantityList = quantityDropdown.querySelector(".dropdown-options");
                  if (quantityHeader && quantityList) {
                      quantityHeader.textContent = newQuantity.replace("3.5g ", "");
                      quantityList.querySelectorAll("li").forEach((li) => {
                          li.classList.toggle("selected", li.dataset.value === newQuantity);
                      });
                      quantityDropdown.classList.add("variant-picked");
                  }
              }
              recalcPrice();
          } else {
              // Clear back design and reset customizeBack
              state.customizeBack = false; // Reset customizeBack
              state.back.image = null;
              state.back.imageUrl = null;
              state.back.imageTransform = null;
              state.back.qrCode = "No";
              state.back.qrCodeLink = "";
              state.back.qrCodePlacement = "NONE";
              const backPreviewImg = document.getElementById("preview-image-image-b2");
              const backArtbox = document.getElementById("upload-artbox-image-b2");
              const backPreviewBox = document.getElementById("preview-box-image-b2");
              if (backPreviewImg) backPreviewImg.src = "";
              if (backArtbox) backArtbox.style.display = "block";
              if (backPreviewBox) backPreviewBox.style.display = "none";
              // Update quantity to remove back customization
              if (state.quantity.includes("FRONT AND BACK")) {
                  const newQuantity = state.quantity.replace("FRONT AND BACK", "FRONT ONLY");
                  state.quantity = newQuantity;
                  const quantityHeader = quantityDropdown.querySelector(".selected-text");
                  const quantityList = quantityDropdown.querySelector(".dropdown-options");
                  if (quantityHeader && quantityList) {
                      quantityHeader.textContent = newQuantity.replace("3.5g ", "");
                      quantityList.querySelectorAll("li").forEach((li) => {
                          li.classList.toggle("selected", li.dataset.value === newQuantity);
                      });
                      quantityDropdown.classList.add("variant-picked");
                  }
              }
              recalcPrice();
          }
      });
  }

  // =============================================
  // 14. FORM VALIDATION
  // =============================================
  function validateForm() {
    let firstInvalid = null;
    function toggleError(id, show, message = "") {
      const bar = document.getElementById(id);
      if (!bar) return;
      if (message) bar.textContent = message;
      bar.style.display = show ? "block" : "none";
      const variantBox = bar.closest(".pcs-variant");
      if (variantBox) variantBox.classList.toggle("has-error", show);
      if (show && !firstInvalid) firstInvalid = variantBox || bar;
    }
    toggleError("size-error-bar", !state.size, "Please select a size.");
    toggleError(
      "material-error-bar",
      !state.material,
      "Please select a material."
    );
    toggleError(
      "quantity-error-bar",
      !state.quantity,
      "Please select a quantity."
    );
    if (state.front.qrCode === "Yes") {
      const qrCodeLink = state.front.qrCodeLink.trim();
      toggleError(
        "qr-code-link-error-bar-b1",
        !qrCodeLink,
        "Please enter a valid QR code link."
      );
      toggleError(
        "qr-code-placement-error-bar-b1",
        state.front.qrCodePlacement === "NONE",
        "Please select a QR code placement."
      );
    }
    if (firstInvalid) {
      firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
      return false;
    }
    return true;
  }

  // =============================================
  // 15. ADD TO CART FUNCTIONALITY
  // =============================================
  function setupApippaAddToCart() {
    const addToCartBtn = document.getElementById("pcs-add-to-cart");
    if (!addToCartBtn) return;
    addToCartBtn.addEventListener("click", async (e) => {
      e.preventDefault();
      if (!validateForm()) {
        console.log("Form invalid – fix the highlighted fields.");
        return;
      }
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add("loading");
      addToCartBtn.innerHTML = `
                      <div class="pcs-loader"></div>
                      <p class="pcs-message"></p>
                      <div class="dot-falling"></div>
                  `;
      const messageEl = addToCartBtn.querySelector(".pcs-message");
      const messages = ["Adding to cart", "GETTING THINGS READY"];
      let messageIndex = 0;
      let stopTypingLoop = false;
      const startTypingLoop = async () => {
        while (!stopTypingLoop) {
          const message = messages[messageIndex % messages.length];
          await typeText(messageEl, message);
          await new Promise((resolve) => setTimeout(resolve, 2000));
          await deleteText(messageEl);
          messageIndex++;
        }
      };
      startTypingLoop();
      const loadingBar = addToCartBtn.querySelector(".pcs-loader");
      let progress = 0;
      const target = 99;
      const interval = setInterval(() => {
        if (progress < 50) {
          progress += 2;
        } else if (progress < 80) {
          progress += (80 - progress) * 0.05;
        } else if (progress < target - 0.2) {
          progress += (target - progress) * 0.05;
        } else {
          progress = target - 0.01;
          clearInterval(interval);
        }
        loadingBar.style.transform = `scaleX(${Math.floor(progress) / 100})`;
      }, 80);
      try {
        state.extraForBack = state.quantity.includes("FRONT AND BACK") ? 0 : 0; // Handled in quantity pricing
        recalcPrice();
        const backActive = state.customizeBack && isBoardCustomized(state.back);
        const requestData = {
          calculatorId: "3974b76cd18e4",
          productId: 7721404596272,
          properties: {
            Size: state.size,
            "Front Image": state.front.image?.name || "",
            "Back Image": backActive ? state.back.image?.name || "" : "",
            "Front Edited": state.editedFront?.name || "",
            "Back Edited": backActive ? state.editedBack?.name || "" : "",
            "QR Code": state.front.qrCode,
            "QR Code Link": state.front.qrCodeLink || "",
            "QR Code Placement":
              state.front.qrCode === "Yes" ? state.front.qrCodePlacement : "",
            "Bag Color": state.front.bagColor,
            Material: state.material,
            Quantity: state.quantity,
            "Is Back Customized?": backActive ? "Yes" : "No",
            "Same as Front Design?": state.sameDesignBack ? "Yes" : "No"
          },
        };
        console.log("Request Data: ", requestData);
        const variantRes = await fetch(
          "https://api.custompricecalculator.com/api/v1/variant",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(requestData),
          }
        );
        const variantId = await variantRes.json();
        const shopifyVariantId =
          typeof variantId === "string"
            ? variantId
            : variantId?.variantId || variantId?.id;
        if (!shopifyVariantId) throw new Error("Invalid variant ID");
        const formData = new FormData();
        formData.append("id", shopifyVariantId);
        formData.append("quantity", 1);
        Object.entries(requestData.properties).forEach(([key, value]) => {
          formData.append(`properties[${key}]`, value);
        });
        if (state.front.image) {
          formData.append("properties[Front Image]", state.front.image);
        }
        if (state.customizeBack && state.back.image) {
          formData.append("properties[Back Image]", state.back.image);
        }
        if (state.editedFront) {
          formData.append("properties[Front Edited]", state.editedFront);
        }
        if (state.customizeBack && state.editedBack) {
          formData.append("properties[Back Edited]", state.editedBack);
        }
        const cartAddRes = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        });
        const cartAddJson = await cartAddRes.json();
        console.log("Add to Cart Response:", cartAddJson);
        localStorage.setItem(
          `patched-cart-item-${cartAddJson.id}`,
          JSON.stringify({
            id: cartAddJson.id,
            title: cartAddJson.product_title,
            image: cartAddJson.image,
            price: cartAddJson.price,
          })
        );
        if (!cartAddRes.ok) throw new Error("Failed to add to cart");
        const cartJson = {
          items: [cartAddJson],
          item_count: 1,
          total_price: cartAddJson.final_price,
          original_total_price: cartAddJson.original_price,
          total_discount: 0,
        };
        const timestamp = new Date().getTime();
        await new Promise((resolve) => setTimeout(resolve, 200));
        const sectionHtml = await fetch(
          `/cart?section_id=mini-cart&t=${timestamp}`
        ).then((res) => res.text());
        const fakeDiv = document.createElement("div");
        fakeDiv.innerHTML = sectionHtml;
        const miniCartHTML = fakeDiv.querySelector("cart-drawer")?.outerHTML;
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer && miniCartHTML) {
          cartDrawer.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: {
                cart: {
                  ...cartJson,
                  sections: {
                    "mini-cart": miniCartHTML,
                  },
                },
                openMiniCart: true,
              },
            })
          );
        }
        setTimeout(() => {
          const lineItems = cartDrawer.querySelectorAll("line-item");
          lineItems.forEach((lineItem) => {
            const desktopPriceContainer = lineItem.querySelector(
              ".line-item__price-list-container .price"
            );
            const mobilePriceContainer = lineItem.querySelector(
              ".product-item-meta__price-list-container .price-list.hidden-tablet-and-up .price"
            );
            if (!desktopPriceContainer && !mobilePriceContainer) return;
            const priceText = (
              desktopPriceContainer || mobilePriceContainer
            ).textContent.trim();
            const isFree = /Free|\$0\.00/.test(priceText);
            let variantId;
            const productLink = lineItem.querySelector("a[href*='?variant=']");
            if (productLink?.href.includes("variant=")) {
              variantId = productLink.href.split("variant=")[1].split("&")[0];
            }
            if (!variantId) {
              const removeBtn = lineItem.querySelector(
                "a[href*='/cart/change?id=']"
              );
              const removeHref = removeBtn?.getAttribute("href") || "";
              const match = removeHref.match(/id=(\d+):/);
              variantId = match?.[1];
            }
            if (isFree && variantId == shopifyVariantId) {
              const matchingItem = cartJson.items.find(
                (item) => String(item.id) === variantId
              );
              if (matchingItem) {
                const correctPrice = (matchingItem.price / 100).toFixed(2);
                const imageWrapper = lineItem.querySelector(
                  ".line-item__image-wrapper"
                );
                const productThumbnail = imageWrapper.querySelector(
                  "img.line-item__image"
                );
                const productTitle = lineItem.querySelector(
                  ".product-item-meta .product-item-meta__title"
                );
                if (!productThumbnail) {
                  const imgSrc = document.querySelector(
                    ".product__thumbnail-item .product__thumbnail img"
                  )?.src;
                  if (imgSrc) {
                    imageWrapper.innerHTML += `
                                                  <img src="${imgSrc}" alt="" srcset="${imgSrc}" width="1024" height="1024" loading="lazy" sizes="(max-width: 740px) 80px, 92px" class="line-item__image">
                                              `;
                  }
                }
                if (productTitle.textContent.trim() === "") {
                  productTitle.textContent = document.querySelector(
                    ".product__info .product-meta__title"
                  ).textContent;
                }
                const updatedPriceHTML = `
                                          <span class="visually-hidden">Sale price</span>
                                          $${correctPrice}
                                      `;
                if (desktopPriceContainer) {
                  desktopPriceContainer.innerHTML = updatedPriceHTML;
                }
                if (mobilePriceContainer) {
                  mobilePriceContainer.innerHTML = updatedPriceHTML;
                }
              }
            }
          });
        }, 300);
        setTimeout(async () => {
          const cartJson = await fetch("/cart.js").then((res) => res.json());
          const cartCountEl = document.querySelector("cart-count");
          if (cartCountEl) {
            cartCountEl.textContent = cartJson.item_count;
          }
        }, 300);
        setTimeout(() => {
          const drawerContent = document.querySelector(
            "#shopify-section-mini-cart .drawer__content"
          );
          if (!drawerContent) return;
          const confetti = document.createElement("dotlottie-player");
          confetti.className = "mini-cart-lottie";
          confetti.src =
            "//cdn.shopify.com/s/files/1/0582/5400/0176/files/confetti.json?v=1748024242";
          confetti.setAttribute("background", "transparent");
          confetti.setAttribute("speed", "1");
          confetti.setAttribute("style", "width: 300px; height: 300px");
          confetti.setAttribute("direction", "1");
          confetti.setAttribute("playmode", "normal");
          confetti.setAttribute("autoplay", "");
          drawerContent.prepend(confetti);
          setTimeout(() => {
            confetti.remove();
          }, 3000);
        }, 1000);
      } catch (err) {
        console.error("Apippa Add to Cart Error:", err);
        alert("There was a problem adding your item to the cart.");
      } finally {
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove("loading");
        addToCartBtn.innerHTML = `
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <circle cx="8" cy="21" r="1"></circle>
            <circle cx="19" cy="21" r="1"></circle>
            <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h8.78a2 2 0 0 0 1.95-1.57L21 7H5.12"></path>
          </svg>
          Add to Cart
        `;
        stopTypingLoop = true;
        resetSidebarVariants();
        const previewBox = document.getElementById("preview-box");
        const mainVariants = document.getElementById("main-variants");
        const uploadArtbox = document.getElementById("upload-artbox");
        const btnEditImage = document.getElementById("btnEditImage");
        const artworkVariant = document.getElementById("artwork-variant");
        if (previewBox) {
          previewBox.style.display = "none";
        }
        if (mainVariants) mainVariants.classList.remove("active");
        if (uploadArtbox) uploadArtbox.style.display = "block";
        if (btnEditImage) btnEditImage.style.display = "inline";
        const previewImage1 = document.getElementById("preview-image1");
        const previewImage2 = document.getElementById("preview-image2");
        if (previewImage1) previewImage1.src = "";
        if (previewImage2) previewImage2.src = "";
        const preview2Wrap = document.querySelector(".bag-preview2");
        if (preview2Wrap) preview2Wrap.style.display = "none";
        state.currentBoard = 1;
        document.querySelectorAll(".board-tab").forEach((tab) => {
          const boardNum = parseInt(tab.dataset.board, 10);
          tab.classList.toggle("active", boardNum === 1);
        });
        document.getElementById("image-variant-b1").style.display = "";
        document.getElementById("qr-code-link-variant-b1").style.display = "";
        document.getElementById("qr-code-placement-variant-b1").style.display = "";
        document.getElementById("variants-b1").style.display = "";
        document.getElementById("image-variant-b2").style.display = "none";
        document.getElementById("variants-b2").style.display = "none";
        if (designer) {
          designer.handleRemoveAllImproved();
          designer.renderBoardFromState(1);
        }
        // Reset Size, Material, and Quantity
        state.size = null;
        state.material = "Gloss";
        state.quantity = "QTY 10 FRONT ONLY";
        // Update Size selection UI
        const sizeVariantList = document.querySelector("#size-variant .sticker-variants__list");
        if (sizeVariantList) {
          sizeVariantList.querySelectorAll(".sticker-variant").forEach((el) => {
            el.classList.remove("active");
          });
        }
        // Update Material selection UI
        const materialDropdown = document.getElementById("material-select");
        if (materialDropdown) {
          const materialHeader = materialDropdown.querySelector(".selected-text");
          const materialList = materialDropdown.querySelector(".dropdown-options");
          if (materialHeader && materialList) {
            materialHeader.textContent = "Gloss";
            materialList.querySelectorAll("li").forEach((li) => {
              li.classList.toggle("selected", li.dataset.value === "Gloss");
            });
            materialDropdown.classList.remove("variant-picked");
          }
        }
        // Update Quantity selection UI
        const quantityDropdown = document.getElementById("quantity-select");
        if (quantityDropdown) {
          const quantityHeader = quantityDropdown.querySelector(".selected-text");
          const quantityList = quantityDropdown.querySelector(".dropdown-options");
          if (quantityHeader && quantityList) {
            quantityHeader.textContent = "QTY 10 FRONT ONLY";
            quantityList.querySelectorAll("li").forEach((li) => {
              li.classList.toggle("selected", li.dataset.value === "3.5g QTY 10 FRONT ONLY");
            });
            quantityDropdown.classList.remove("variant-picked");
          }
        }
        // Hide artwork-variant
        if (artworkVariant) {
          artworkVariant.style.display = "none";
        }
        // Clear any error messages
        document.querySelectorAll(".error-bar").forEach((el) => hide(el));
        document.querySelectorAll(".pcs-variant").forEach((el) => el.classList.remove("has-error"));
        recalcPrice();
      }
    });
  }

  // Text animation helpers
  function typeText(el, text, speed = 60) {
    return new Promise((resolve) => {
      let i = 0;
      const typeInterval = setInterval(() => {
        el.textContent += text[i];
        i++;
        if (i >= text.length) {
          clearInterval(typeInterval);
          resolve();
        }
      }, speed);
    });
  }
  function deleteText(el, speed = 40) {
    return new Promise((resolve) => {
      const delInterval = setInterval(() => {
        el.textContent = el.textContent.slice(0, -1);
        if (el.textContent.length === 0) {
          clearInterval(delInterval);
          resolve();
        }
      }, speed);
    });
  }

  // =============================================
  // 16. BOARD SWITCHING
  // =============================================
  function handleCustomizeBackModal(resolve) {
    const customizeBackModal = document.getElementById("customize-back-popup");
    const keepAsFront = document.getElementById("keep-as-front");
    const confirmCustomize = document.getElementById("confirm-customize-back");
    const closeBtn = document.getElementById("customize-back-close-btn");
    if (!customizeBackModal || !keepAsFront || !confirmCustomize || !closeBtn) {
      console.error("Modal or buttons not found");
      resolve(false);
      return;
    }
    customizeBackModal.classList.add("active");
    disableBodyScroll();
    keepAsFront.addEventListener(
      "click",
      () => {
        customizeBackModal.classList.remove("active");
        enableBodyScroll();
        // Check the same design checkbox
        const sameDesignCheckbox = document.getElementById("sameDesignBack");
        if (sameDesignCheckbox) {
          sameDesignCheckbox.checked = true;
          state.sameDesignBack = true;
          // Copy front design to back
          state.customizeBack = true;
          state.back.image = state.front.image;
          state.back.imageUrl = state.front.imageUrl;
          state.back.imageTransform = state.front.imageTransform;
          state.back.qrCode = state.front.qrCode;
          state.back.qrCodeLink = state.front.qrCodeLink;
          state.back.qrCodePlacement = state.front.qrCodePlacement;
          state.back.bagColor = state.front.bagColor;
          // Update back preview
          const backPreviewImg = document.getElementById("preview-image-image-b2");
          const backArtbox = document.getElementById("upload-artbox-image-b2");
          const backPreviewBox = document.getElementById("preview-box-image-b2");
          if (state.front.imageUrl) {
            if (backPreviewImg) backPreviewImg.src = state.front.imageUrl;
            if (backArtbox) backArtbox.style.display = "none";
            if (backPreviewBox) backPreviewBox.style.display = "block";
          } else {
            if (backPreviewImg) backPreviewImg.src = "";
            if (backArtbox) backArtbox.style.display = "block";
            if (backPreviewBox) backPreviewBox.style.display = "none";
          }
          // Update quantity to reflect back customization
          const quantityDropdown = document.getElementById("quantity-select");
          if (quantityDropdown && state.quantity.includes("FRONT ONLY")) {
            const newQuantity = state.quantity.replace("FRONT ONLY", "FRONT AND BACK");
            state.quantity = newQuantity;
            const quantityHeader = quantityDropdown.querySelector(".selected-text");
            const quantityList = quantityDropdown.querySelector(".dropdown-options");
            if (quantityHeader && quantityList) {
              quantityHeader.textContent = newQuantity.replace("3.5g ", "");
              quantityList.querySelectorAll("li").forEach((li) => {
                li.classList.toggle("selected", li.dataset.value === newQuantity);
              });
              quantityDropdown.classList.add("variant-picked");
            }
          }
          recalcPrice();
          // Disable Back tab buttons
          const backTabButtons = document.querySelectorAll('.board-tab[data-board="2"]');
          backTabButtons.forEach(btn => {
            btn.disabled = true;
            btn.style.opacity = '0.5';
            btn.style.cursor = 'not-allowed';
          });
        }
        resolve(false);
      },
      { once: true }
    );
    confirmCustomize.addEventListener(
      "click",
      () => {
        customizeBackModal.classList.remove("active");
        document
          .querySelector(".sidebar")
          .scrollTo({ top: 0, behavior: "smooth" });
        enableBodyScroll();
        resolve(true);
      },
      { once: true }
    );
    closeBtn.addEventListener(
      "click",
      () => {
        customizeBackModal.classList.remove("active");
        enableBodyScroll();
        resolve(false);
      },
      { once: true }
    );
  }

  function setupBoardSwitching() {
      const tabs = document.querySelectorAll(".board-tab");
      tabs.forEach((tab) => {
          tab.addEventListener("click", async (e) => {
              const newBoard = parseInt(e.currentTarget.dataset.board, 10);
              if (newBoard === state.currentBoard) return;
              if (newBoard === 2 && state.sameDesignBack) return; // Prevent switching if same design is checked
              saveCurrentBoardState();
              if (newBoard === 2 && !state.back.imageUrl) { // Check if back image is not uploaded
                  const confirmed = await new Promise((resolve) => {
                      handleCustomizeBackModal(resolve);
                  });
                  if (!confirmed) return;
                  state.customizeBack = true;
                  state.back = {
                      image: null,
                      imageUrl: null,
                      imageTransform: null,
                      bagColor: state.front.bagColor,
                  };
                  document.getElementById("image-variant-b2").style.display = "";
                  document.getElementById("variants-b2").style.display = "";
                  recalcPrice();
              }
              state.currentBoard = newBoard;
              document.getElementById("image-variant-b1").style.display =
                  newBoard === 1 ? "" : "none";
              document.getElementById("image-variant-b2").style.display =
                  newBoard === 2 && (state.customizeBack || state.back.imageUrl) ? "" : "none";
              document.getElementById("variants-b1").style.display =
                  newBoard === 1 ? "" : "none";
              document.getElementById("variants-b2").style.display =
                  newBoard === 2 && (state.customizeBack || state.back.imageUrl) ? "" : "none";
              document
                  .querySelectorAll(".board-tab")
                  .forEach((t) =>
                      t.classList.toggle(
                          "active",
                          parseInt(t.dataset.board, 10) === newBoard
                      )
                  );
              await designer.renderBoardFromState(newBoard);
              loadCurrentBoardState();
          });
      });
      // Initialize Back tab button state based on sameDesignBack
      const backTabButtons = document.querySelectorAll('.board-tab[data-board="2"]');
      backTabButtons.forEach(btn => {
          btn.disabled = state.sameDesignBack;
          btn.style.opacity = state.sameDesignBack ? '0.5' : '1';
          btn.style.cursor = state.sameDesignBack ? 'not-allowed' : 'pointer';
      });
  }

  function saveCurrentBoardState() {
    const suf = state.currentBoard === 1 ? "b1" : "b2";
    const boardState = state[state.currentBoard === 1 ? "front" : "back"];
    const artbox = document.getElementById(`upload-artbox-image-${suf}`);
    const previewBox = document.getElementById(`preview-box-image-${suf}`);
    if (artbox && previewBox) {
      boardState.imageUrl =
        previewBox.style.display === "block"
          ? document.getElementById(`preview-image-image-${suf}`).src
          : null;
    }
    if (state.currentBoard === 1) {
      const qrCodeList = document.querySelector(
        "#qr-code-variant-b1 .sticker-variants__list .sticker-variant.active"
      );
      if (qrCodeList) boardState.qrCode = qrCodeList.dataset.qrCode || "No";
      const qrCodeLinkInput = document.getElementById("qr-code-link-input-b1");
      if (qrCodeLinkInput) boardState.qrCodeLink = qrCodeLinkInput.value;
      const placementList = document.querySelector(
        "#qr-code-placement-variant-b1 .sticker-variants__list .sticker-variant.active"
      );
      if (placementList)
        boardState.qrCodePlacement = placementList.dataset.placement || "NONE";
      const bagColorList = document.querySelector(
        "#bag-color-variant-b1 .sticker-variants__list .sticker-variant.active"
      );
      if (bagColorList) {
        boardState.bagColor = bagColorList.dataset.color || "No Bag";
        state.back.bagColor = boardState.bagColor; // Sync back bag color
      }
      // If same design is checked, sync front changes to back
      if (state.sameDesignBack) {
        state.back.image = state.front.image;
        state.back.imageUrl = state.front.imageUrl;
        state.back.imageTransform = state.front.imageTransform;
        state.back.qrCode = state.front.qrCode;
        state.back.qrCodeLink = state.front.qrCodeLink;
        state.back.qrCodePlacement = state.front.qrCodePlacement;
        state.back.bagColor = state.front.bagColor;
        const backPreviewImg = document.getElementById("preview-image-image-b2");
        const backArtbox = document.getElementById("upload-artbox-image-b2");
        const backPreviewBox = document.getElementById("preview-box-image-b2");
        if (state.front.imageUrl) {
          if (backPreviewImg) backPreviewImg.src = state.front.imageUrl;
          if (backArtbox) backArtbox.style.display = "none";
          if (backPreviewBox) backPreviewBox.style.display = "block";
        } else {
          if (backPreviewImg) backPreviewImg.src = "";
          if (backArtbox) backArtbox.style.display = "block";
          if (backPreviewBox) backPreviewBox.style.display = "none";
        }
      }
    }
    if (designer) {
      if (designer.backgroundImage) {
        if (typeof designer.backgroundImage.getSrc === "function") {
          boardState.imageUrl = designer.backgroundImage.getSrc();
        }
        boardState.imageTransform = designer._snapshotObj(
          designer.backgroundImage
        );
      } else if (!boardState.imageUrl) {
        boardState.imageUrl = null;
        boardState.imageTransform = null;
      }
      if (designer.qrCodeImage && state.currentBoard === 1) {
        boardState.qrCodeTransform = designer._snapshotObj(
          designer.qrCodeImage
        );
      } else if (state.currentBoard === 1) {
        boardState.qrCodeTransform = null;
      }
    }
  }

  function syncSidebarToBoardState(boardIndex) {
    const bs = state[boardIndex === 1 ? "front" : "back"];
    const suf = boardIndex === 1 ? "b1" : "b2";
    const artbox = document.getElementById(`upload-artbox-image-${suf}`);
    const previewBox = document.getElementById(`preview-box-image-${suf}`);
    const previewImg = document.getElementById(`preview-image-image-${suf}`);
    if (bs.imageUrl) {
      if (artbox) artbox.style.display = "none";
      if (previewBox) previewBox.style.display = "block";
      if (previewImg) previewImg.src = bs.imageUrl;
    } else {
      if (artbox) artbox.style.display = "block";
      if (previewBox) previewBox.style.display = "none";
      if (previewImg) previewImg.src = "";
    }
    if (boardIndex === 1) {
      const qrCodeList = document.querySelectorAll(
        "#qr-code-variant-b1 .sticker-variants__list .sticker-variant"
      );
      qrCodeList.forEach((el) =>
        el.classList.toggle("active", el.dataset.qrCode === bs.qrCode)
      );
      const qrCodeLinkInput = document.getElementById("qr-code-link-input-b1");
      const qrCodeLinkCounter = document.getElementById(
        "qr-code-link-char-count-b1"
      );
      const qrCodeLinkError = document.getElementById(
        "qr-code-link-error-bar-b1"
      );
      if (qrCodeLinkInput) {
        qrCodeLinkInput.value = bs.qrCodeLink || "";
        const hasLink = !!bs.qrCodeLink;
        qrCodeLinkInput.parentElement.classList.toggle(
          "variant-picked",
          hasLink
        );
        if (qrCodeLinkCounter) {
          qrCodeLinkCounter.textContent = `${
            1000 - qrCodeLinkInput.value.length
          } character(s) left`;
        }
        if (qrCodeLinkError)
          qrCodeLinkError.style.display = hasLink ? "none" : "block";
      }
      const placementList = document.querySelectorAll(
        "#qr-code-placement-variant-b1 .sticker-variants__list .sticker-variant"
      );
      placementList.forEach((el) =>
        el.classList.toggle(
          "active",
          el.dataset.placement === bs.qrCodePlacement
        )
      );
      const bagColorList = document.querySelectorAll(
        "#bag-color-variant-b1 .sticker-variants__list .sticker-variant"
      );
      bagColorList.forEach((el) =>
        el.classList.toggle("active", el.dataset.color === bs.bagColor)
      );
      const qrCodeLinkVariant = document.getElementById(
        "qr-code-link-variant-b1"
      );
      const qrCodePlacementVariant = document.getElementById(
        "qr-code-placement-variant-b1"
      );
      if (bs.qrCode === "Yes") {
        show(qrCodeLinkVariant);
        show(qrCodePlacementVariant);
        if (designer) {
          designer.updateQRCode();
        }
      } else {
        hide(qrCodeLinkVariant);
        hide(qrCodePlacementVariant);
      }
    }
    document
      .querySelectorAll(".error-bar")
      .forEach((el) => (el.style.display = "none"));
    document
      .querySelectorAll(".pcs-variant")
      .forEach((el) => el.classList.remove("has-error"));
  }

  function loadCurrentBoardState() {
    const idx = state.currentBoard;
    const bs = state[idx === 1 ? "front" : "back"];
    syncSidebarToBoardState(idx);
    if (designer) {
      designer.canvas.clear();
      designer.canvas.clipPath = null;
      designer.backgroundRect = null;
      designer.backgroundImage = null;
      designer.qrCodeImage = null;
      designer.guidelineObjects = [];
      designer.drawClipPath();
      if (designer.backgroundRect) {
        designer.backgroundRect.set({
          fill: COLOR_MAPPINGS[bs.bagColor] || "#000000",
          stroke: bs.bagColor === "White Bag" ? "#d9d9d9" : "none",
        });
      }
      if (bs.imageUrl) {
        fabric.Image.fromURL(
          bs.imageUrl,
          (img) => {
            designer._placeImage(img, bs.imageTransform);
            designer.canvas.renderAll();
          },
          { crossOrigin: "anonymous" }
        );
      }
      if (idx === 1 && bs.qrCode === "Yes" && !designer.qrCodeImage) {
        designer.updateQRCodePlacement(bs.qrCodePlacement);
      }
      designer.canvas.renderAll();
      designer.updateFinishButtonState();
    }
  }

  // =============================================
  // 17. MYLAR BAG DESIGNER CLASS
  // =============================================
  class MylarBagDesigner {
    constructor() {
      this.canvas = null;
      this.clipPath = null;
      this.backgroundImage = null;
      this.qrCodeImage = null;
      this.guidelineObjects = [];
      this.freezeLayout = false;
      this._renderToken = 0;
      this.snappingEnabled = true;
      this._qrLoading = false;
      this._qrToken = 0;
      this._ro = null;
      this.qrMargins = { mobile: 18, desktop: 30 };
      this.icons = {
        resizeLeft:
          "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/white-resize-left.webp",
        resizeRight:
          "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/white-resize-right.webp",
        resizeHorizontal:
          "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/white-resize-horizontal.webp",
        stackUp:
          "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/stackup.webp",
        stackDown:
          "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/stackdown.webp",
        rotate:
          "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/rotate.webp",
      };
      this.frameImages = {
        "No Bag":
          "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/Frame.png",
        "Black Bag":
          "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/Frame.png",
        "White Bag":
          "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/White-Frame.png?v=1758642623",
        "Chrome Bag":
          "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/Chrome-Frame.png?v=1758643001",
      };
      this.qrCodeImageUrl =
        "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/qr-code-link.png";

      this.mobileGuideMargin = 12; // Smaller margin for mobile
      this.mobileGuideCornerRadius = 12; // Smaller radius for mobile
      this.desktopGuideMargin = 20;
      this.desktopGuideCornerRadius = 26;

      this.init();
    }

    init() {
      const canvasContainer = document.getElementById("canvasContainer");
      if (!canvasContainer) {
        console.error("Canvas container not found");
        return;
      }
      canvasContainer.innerHTML = '<canvas id="stickerCanvas"></canvas>';
      this.canvas = new fabric.Canvas("stickerCanvas", {
        width: canvasContainer.offsetWidth,
        height: canvasContainer.offsetHeight,
        preserveObjectStacking: true,
        controlsAboveOverlay: true,
        selection: true,
        backgroundColor: "white",
      });
      this.setupCanvas();
      this.setupEventListeners();
      this.setupCustomControls();
      this.observeContainerResize(canvasContainer);
      this.updateCanvasSize();
      this.updateFinishButtonState();
    }

    observeContainerResize(container) {
      const ro = new ResizeObserver(
        this.debounce(() => this.handleResize(), 120)
      );
      ro.observe(container);
      this._ro = ro;
    }

    setupCanvas() {
      if (!this.canvas) return;
      this.canvas.preserveObjectStacking = true;
      this.canvas.controlsAboveOverlay = true;
      this.canvas.selection = true;
    }

    setupEventListeners() {
      window.addEventListener(
        "resize",
        this.debounce(() => this.handleResize(), 300)
      );
      document.addEventListener("keydown", (e) => {
        const obj = this.canvas?.getActiveObject();
        if (!obj) return;
        const mod = e.ctrlKey || e.metaKey;
        if (mod && e.key === "]") {
          const cur = this.canvas.getObjects().indexOf(obj);
          const maxIdx = this._topCeilingIndex();
          if (cur < maxIdx) this.canvas.bringForward(obj);
          this._guardZ(obj);
          e.preventDefault();
        } else if (mod && e.key === "[") {
          const cur = this.canvas.getObjects().indexOf(obj);
          const minIdx = this._bgTopIndex() + 1;
          if (cur > minIdx) this.canvas.sendBackwards(obj);
          this._guardZ(obj);
          e.preventDefault();
        }
      });
      const getStartedBtn = document.getElementById("get-started-btn");
      if (getStartedBtn) {
        getStartedBtn.addEventListener("click", async () => {
          const designerTool = document.getElementById("designerTool");
          const imageVariantB1 = document.getElementById("image-variant-b1");
          const chooseFileBtn = document.getElementById("choose-file-btn-image-b1");
          if (designerTool) {
            designerTool.classList.add("active");
            await new Promise((resolve) => requestAnimationFrame(resolve));
            this.handleResize();
            blinkVariantElement(imageVariantB1.querySelector(".artwork-box"));
            if (chooseFileBtn.classList.contains("shine")) {
              chooseFileBtn.classList.remove("shine");
            }
            setTimeout(() => {
              chooseFileBtn.classList.add("shine");
            }, 500);
            this.disableBodyScroll();
            await this.renderBoardFromState(state.currentBoard);
          }
        });
      }
      const closeBtn = document.getElementById("designer-tool-close-btn");
      if (closeBtn) {
        closeBtn.addEventListener("click", () => {
          const popup = document.getElementById("close-tool-popup");
          if (popup) popup.classList.add("active");
        });
      }
      const cancelClose = document.getElementById("cancel-close-tool");
      if (cancelClose) {
        cancelClose.addEventListener("click", () => {
          const popup = document.getElementById("close-tool-popup");
          if (popup) popup.classList.remove("active");
        });
      }
      const confirmClose = document.getElementById("confirm-close-tool");
      if (confirmClose) {
        confirmClose.addEventListener("click", () => {
          const popup = document.getElementById("close-tool-popup");
          const designerTool = document.getElementById("designerTool");
          if (popup) popup.classList.remove("active");
          if (designerTool) {
            designerTool.classList.remove("active");
            this.enableBodyScroll();
          }
        });
      }
      const finishEditing = document.getElementById("finishEditing");
      if (finishEditing) {
        finishEditing.addEventListener("click", () => this.finishEditing());
      } 
      const toggleGuides = document.getElementById("toggleGuides");
      if (toggleGuides) {
        toggleGuides.addEventListener("change", (e) => {
          this.toggleGuidelines(e.target.checked);
        });
      }
      const toggleSnap = document.getElementById("toggleSnap");
      if (toggleSnap) {
        toggleSnap.addEventListener("change", (e) => {
          this.snappingEnabled = e.target.checked;
        });
      }
      const btnEditImage = document.getElementById("btnEditImage");
      if (btnEditImage) {
        btnEditImage.addEventListener("click", async () => {
          const designerTool = document.getElementById("designerTool");
          if (designerTool) {
            designerTool.classList.add("active");
            await new Promise((resolve) => requestAnimationFrame(resolve));
            this.handleResize();
            this.disableBodyScroll();
            await this.renderBoardFromState(state.currentBoard);
          }
        });
      }
      const addQRCodeBtn = document.getElementById("addQRCodeBtn");
      if (addQRCodeBtn) {
        addQRCodeBtn.addEventListener("click", () => {
          console.log("Add QR Code button clicked");
          this.addQRCode();
        });
      }
      document
        .querySelectorAll(".align-btn")
        .forEach((btn) =>
          btn.addEventListener("click", (e) =>
            this.alignObjects(e.currentTarget.dataset.align)
          )
        );
      this.canvas.on("selection:created", (e) => {
        const onlyOne = e.selected && e.selected.length === 1;
        if (onlyOne) {
          const obj = e.selected[0];
          const suf = state.currentBoard === 1 ? "b1" : "b2";
          let targetId;
          if (obj === this.backgroundImage) {
            targetId = `image-variant-${suf}`;
          } else if (obj === this.qrCodeImage) {
            targetId = `qr-code-link-variant-b1`;
          }
          if (targetId) {
            const targetEl = document.getElementById(targetId);
            if (targetEl) {
              const scroller = this.findScrollableParent(targetEl);
              if (scroller) {
                const rectTarget = targetEl.getBoundingClientRect();
                const rectScroller = scroller.getBoundingClientRect();
                const offset = rectTarget.top - rectScroller.top;
                const centering =
                  scroller.clientHeight / 2 - rectTarget.height / 2;
                const scrollToPos = scroller.scrollTop + offset - centering;
                scroller.scrollTo({ top: scrollToPos, behavior: "smooth" });
              } else {
                targetEl.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
              }
            }
          }
        }
      });
      this.canvas.on("selection:updated", (e) => {
        const onlyOne = e.selected && e.selected.length === 1;
        if (onlyOne) {
          const obj = e.selected[0];
          const suf = state.currentBoard === 1 ? "b1" : "b2";
          let targetId;
          if (obj === this.backgroundImage) {
            targetId = `image-variant-${suf}`;
          } else if (obj === this.qrCodeImage) {
            targetId = `qr-code-link-variant-b1`;
          }
          if (targetId) {
            const targetEl = document.getElementById(targetId);
            if (targetEl) {
              const scroller = this.findScrollableParent(targetEl);
              if (scroller) {
                const rectTarget = targetEl.getBoundingClientRect();
                const rectScroller = scroller.getBoundingClientRect();
                const offset = rectTarget.top - rectScroller.top;
                const centering =
                  scroller.clientHeight / 2 - rectTarget.height / 2;
                const scrollToPos = scroller.scrollTop + offset - centering;
                scroller.scrollTo({ top: scrollToPos, behavior: "smooth" });
              } else {
                targetEl.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
              }
            }
          }
        }
      });
      this.canvas.on("selection:cleared", () => {});
      this.canvas.on("object:modified", () => {
        if (typeof saveCurrentBoardState === "function")
          saveCurrentBoardState();
      });
      this.canvas.on("object:moving", (e) => {
        if (!this.snappingEnabled || !this.clipPath) return;
        const obj = e.target;
        if (!obj) return;
        const threshold = 10;
        const cur = obj.getCenterPoint();
        const clipBR = this.clipPath.getBoundingRect(true);
        const clipCX = clipBR.left + clipBR.width / 2;
        const clipCY = clipBR.top + clipBR.height / 2;
        let targetCX = cur.x;
        let targetCY = cur.y;
        if (Math.abs(cur.x - clipCX) <= threshold) targetCX = clipCX;
        if (Math.abs(cur.y - clipCY) <= threshold) targetCY = clipCY;
        obj.setPositionByOrigin(
          new fabric.Point(targetCX, targetCY),
          "center",
          "center"
        );
        obj.setCoords();
        this.canvas.requestRenderAll();
      });
      this.canvas.on("object:added", (e) => {
        if (this.guidelineObjects.length) this._bringGuidesToFront();
      });
    }

    setupCustomControls() {
      const preload = (src) =>
        new Promise((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = "anonymous";
          img.onload = () => resolve(img);
          img.onerror = reject;
          img.src = src;
        });
      Promise.all([
        preload(this.icons.resizeLeft),
        preload(this.icons.resizeRight),
        preload(this.icons.resizeHorizontal),
        preload(this.icons.stackUp),
        preload(this.icons.stackDown),
        preload(this.icons.rotate),
      ])
        .then(
          ([
            resizeLeftImg,
            resizeRightImg,
            resizeHImg,
            stackUpImg,
            stackDownImg,
            rotateImg,
          ]) => {
            this.applyCustomCornerIcons(
              resizeLeftImg,
              resizeRightImg,
              resizeHImg,
              stackUpImg,
              stackDownImg,
              rotateImg
            );
          }
        )
        .catch((e) => console.warn("Icon preload failed:", e));
      fabric.Object.prototype.transparentCorners = false;
      fabric.Object.prototype.cornerColor = "black";
      fabric.Object.prototype.borderColor = "black";
      fabric.Object.prototype.cornerStyle = "circle";
      fabric.Object.prototype.cornerStrokeColor = "black";
      fabric.Object.prototype.borderScaleFactor = 1;
    }

    applyCustomCornerIcons(
      iconLeft,
      iconRight,
      iconHorizontal,
      iconStackUp,
      iconStackDown,
      iconRotate
    ) {
      const renderIcon = (icon) =>
        function (ctx, left, top, _style, fabricObject) {
          const size = this.cornerSize || 24;
          ctx.save();
          ctx.translate(left, top);
          ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle || 0));
          ctx.drawImage(icon, -size / 2, -size / 2, size, size);
          ctx.restore();
        };
      const setCtrl = (key, opts) => {
        const ctrl = fabric.Object.prototype.controls[key];
        if (ctrl) Object.assign(ctrl, opts);
      };
      const cornerSize = 25;
      setCtrl("tl", { render: renderIcon(iconLeft), cornerSize });
      setCtrl("tr", { render: renderIcon(iconRight), cornerSize });
      setCtrl("bl", { render: renderIcon(iconRight), cornerSize });
      setCtrl("br", { render: renderIcon(iconLeft), cornerSize });
      const midSize = 25;
      setCtrl("ml", {
        render: renderIcon(iconHorizontal),
        cornerSize: midSize,
      });
      setCtrl("mr", {
        render: renderIcon(iconHorizontal),
        cornerSize: midSize,
      });
      fabric.Object.prototype.setControlsVisibility({
        mt: false,
        mb: false,
        ml: false,
        mr: false,
      });
      const self = this;
      const ICON_SIZE = 25;
      const OFFSET_X = 25;
      const OFFSET_Y = 12;
      const GAP_Y = 6;
      const makeTopRightControl = (name, order, iconImg, onClick) => {
        fabric.Object.prototype.controls[name] = new fabric.Control({
          x: 0.5,
          y: -0.5,
          offsetX: OFFSET_X,
          offsetY: OFFSET_Y + order * (ICON_SIZE + GAP_Y),
          cornerSize: ICON_SIZE,
          cursorStyle: "pointer",
          render: renderIcon(iconImg),
          mouseUpHandler: (_evt, transform) => {
            const obj = transform.target;
            if (!obj || !obj.canvas) return;
            onClick(obj);
            self._guardZ(obj);
            obj.canvas.setActiveObject(obj);
            obj.canvas.requestRenderAll();
          },
        });
      };
      makeTopRightControl("bringFwd", 0, iconStackUp, (obj) => {
        const cur = obj.canvas.getObjects().indexOf(obj);
        const maxIdx = self._topCeilingIndex();
        if (cur < maxIdx) obj.canvas.bringForward(obj);
      });
      makeTopRightControl("sendBack", 1, iconStackDown, (obj) => {
        const cur = obj.canvas.getObjects().indexOf(obj);
        const minIdx = self._bgTopIndex() + 1;
        if (cur > minIdx) obj.canvas.sendBackwards(obj);
      });
      const ROTATE_SIZE = 26;
      const ROTATE_OFFSETY = -32;
      fabric.Object.prototype.controls.mtr = new fabric.Control({
        x: 0,
        y: -0.5,
        offsetY: ROTATE_OFFSETY,
        cornerSize: ROTATE_SIZE,
        cursorStyleHandler: fabric.controlsUtils.rotationStyleHandler,
        actionHandler: fabric.controlsUtils.rotationWithSnapping,
        actionName: "rotate",
        render: renderIcon(iconRotate),
        withConnection: true,
        connectionStyle: { stroke: "#000", strokeWidth: 1 },
      });
    }

    _topCeilingIndex() {
      if (!this.canvas) return -1;
      const objs = this.canvas.getObjects();
      let minGuide = Infinity;
      this.guidelineObjects.forEach((g) => {
        const idx = objs.indexOf(g);
        if (idx !== -1) minGuide = Math.min(minGuide, idx);
      });
      return minGuide === Infinity ? objs.length - 1 : minGuide - 1;
    }

    _bringGuidesToFront() {
      if (!this.canvas) return;
      this.guidelineObjects.forEach((g) => this.canvas.bringToFront(g));
      this.canvas.requestRenderAll();
    }

    _bgTopIndex() {
      if (!this.canvas) return -1;
      const objs = this.canvas.getObjects();
      let idx = -1;
      if (this.backgroundImage)
        idx = Math.max(idx, objs.indexOf(this.backgroundImage));
      return idx;
    }

    _guardZ(obj) {
      if (!this.canvas || !obj) return;
      if (this.guidelineObjects?.length) this._bringGuidesToFront();
      const objs = this.canvas.getObjects();
      const bgTop = this._bgTopIndex();
      const topCap = this._topCeilingIndex();
      let cur = objs.indexOf(obj);
      if (bgTop >= 0 && cur <= bgTop) this.canvas.moveTo(obj, bgTop + 1);
      cur = objs.indexOf(obj);
      if (topCap >= 0 && cur > topCap) this.canvas.moveTo(obj, topCap);
      this.canvas.requestRenderAll();
    }

    ppiX() {
      if (!this.clipPath) return 1;
      const { width } = this.getBagSize();
      return this.clipPath.width / width;
    }

    ppiY() {
      if (!this.clipPath) return 1;
      const { height } = this.getBagSize();
      return this.clipPath.height / height;
    }

    updateCanvasSize() {
      const container = document.getElementById("canvasContainer");
      if (!container || !this.canvas) return;
      if (container.clientWidth === 0 && container.clientHeight === 0) return;

      const { width: wIn, height: hIn } = this.getBagSize();
      const ratio = wIn / hIn;
      const small = window.matchMedia("(max-width: 640px)").matches;

      let widthPx, heightPx;

      if (small) {
        // Mobile-specific sizing - use the same logic as drawClipPath
        const containerWidth = Math.max(1, container.clientWidth || 1);
        const containerHeight = Math.max(
          1,
          container.clientHeight || Math.floor(window.innerHeight * 0.42)
        );
        
        const nearSquare = ratio >= 0.9 && ratio <= 1.1;
        const midSquare = ratio > 0.75 && ratio < 1.33;
        const shrink = nearSquare ? 0.75 : midSquare ? 0.85 : 0.9;
        
        // Calculate height first, then width from ratio
        let tempHeight = Math.round((containerWidth / ratio) * shrink);
        const maxVH = Math.floor(window.innerHeight * 0.38);
        heightPx = Math.min(tempHeight, maxVH, Math.floor(containerHeight * 0.88));
        widthPx = Math.round(heightPx * ratio);
        
        // Ensure it fits within container
        if (widthPx > containerWidth * 0.95) {
          widthPx = containerWidth * 0.95;
          heightPx = Math.round(widthPx / ratio);
        }
      } else {
        // Desktop sizing
        const fill = 0.8;
        const maxW = container.clientWidth * fill;
        const maxH = container.clientHeight * fill;
        widthPx = ratio > maxW / maxH ? maxW : maxH * ratio;
        heightPx = ratio > maxW / maxH ? maxW / ratio : maxH;
      }

      this.canvas.setDimensions({ width: widthPx, height: heightPx });
      this.canvas.calcOffset();
      this.canvas.renderAll();
  }

    getBagSize() {
      return { width: 5, height: 8 };
    }

    mobileFillForRatio(ratio) {
      if (ratio >= 0.9 && ratio <= 1.1) return 0.88;
      if (ratio >= 1.6 || ratio <= 0.625) return 0.95;
      return 0.9;
    }

    hasContent() {
      const boardState = state[state.currentBoard === 1 ? "front" : "back"];
      return (
        !!boardState.imageUrl ||
        (state.currentBoard === 1 && boardState.qrCode === "Yes")
      );
    }

    updateFinishButtonState() {
      const finishEditing = document.getElementById("finishEditing");
      if (finishEditing) {
        finishEditing.disabled = !this.hasContent();
      }
    }

    _snapshotObj(obj) {
      if (!obj || !this.clipPath) return null;
      const b = this.clipPath.getBoundingRect(true);
      return {
        cx: (obj.left - b.left) / b.width,
        cy: (obj.top - b.top) / b.height,
        scaleX: obj.scaleX,
        scaleY: obj.scaleY,
        angle: obj.angle || 0,
        originX: obj.originX || "center",
        originY: obj.originY || "center",
        clipW: b.width,
        clipH: b.height,
      };
    }

    _applySnapshot(obj, snap) {
      if (!obj || !snap || !this.clipPath) return;
      const b = this.clipPath.getBoundingRect(true);
      obj.set({
        left: b.left + snap.cx * b.width,
        top: b.top + snap.cy * b.height,
        originX: snap.originX,
        originY: snap.originY,
        scaleX: snap.scaleX || 1,
        scaleY: snap.scaleY || 1,
        angle: snap.angle || 0,
      });
      obj.setCoords();
    }

    drawClipPath() {
      if (!this.canvas) return;
      if (this.freezeLayout && this.clipPath) return;

      const container = document.getElementById("canvasContainer");
      if (!container) return;

      // Keep current non-guide objects so we can re-add them after clearing
      const keep = [this.backgroundImage, this.qrCodeImage]
        .filter(Boolean);

      // Start clean (guides, frame, everything)
      this.canvas.clear();

      const { width: wIn, height: hIn } = this.getBagSize();
      const ratio = wIn / hIn;
      const small = window.matchMedia("(max-width: 640px)").matches;

      let widthPx, heightPx;
      if (small) {
        const containerWidth = Math.max(1, container.clientWidth || 1);
        const containerHeight = Math.max(
          1,
          container.clientHeight || Math.floor(window.innerHeight * 0.42)
        );
        const nearSquare = ratio >= 0.9 && ratio <= 1.1;
        const midSquare = ratio > 0.75 && ratio < 1.33;
        const shrink = nearSquare ? 0.75 : midSquare ? 0.85 : 0.9;
        let tempHeight = Math.round((containerWidth / ratio) * shrink);
        const maxVH = Math.floor(window.innerHeight * 0.38);
        heightPx = Math.min(tempHeight, maxVH, Math.floor(containerHeight * 0.88));
        widthPx = Math.round(heightPx * ratio);
        if (widthPx > containerWidth * 0.95) {
          widthPx = containerWidth * 0.95;
          heightPx = Math.round(widthPx / ratio);
        }
      } else {
        const fill = 0.8;
        const maxW = container.clientWidth * fill;
        const maxH = container.clientHeight * fill;
        widthPx = ratio > maxW / maxH ? maxW : maxH * ratio;
        heightPx = ratio > maxW / maxH ? maxW / ratio : maxH;
      }

      const currentColor = state.front.bagColor || "No Bag";
      const frameUrl = this.frameImages[currentColor];

      // If no frame, just re-add what we kept and draw guides
      if (!frameUrl) {
        this.clipPath = null;
        keep.forEach((obj) => {
          this.canvas.add(obj);
          obj.clipPath = null;
          obj.setCoords();
        });
        this._drawGuides();
        this.canvas.renderAll();
        this.updateFinishButtonState();
        return;
      }

      fabric.Image.fromURL(
        frameUrl,
        (frameImg) => {
          const scaleX = widthPx / frameImg.width;
          const scaleY = heightPx / frameImg.height;
          frameImg.set({
            left: 0,
            top: 0,
            scaleX,
            scaleY,
            originX: "left",
            originY: "top",
            selectable: false,
            evented: false,
          });

          // Add frame first
          this.clipPath = frameImg;
          this.canvas.add(this.clipPath);

          // IMPORTANT: re-add preserved objects that were cleared
          keep.forEach((obj) => {
            this.canvas.add(obj);
            obj.clipPath = null;
            obj.setCoords();
          });

          // Keep proper Z order
          if (this.backgroundImage) this.canvas.sendToBack(this.backgroundImage);
          if (this.qrCodeImage) this.canvas.bringToFront(this.qrCodeImage);

          // Redraw guides last so they’re on top
          this._drawGuides();
          this.canvas.renderAll();
          this.updateFinishButtonState();
        },
        { crossOrigin: "anonymous" }
      );
    }

    _drawGuides() {
      // Remove old guides
      this.guidelineObjects.forEach((o) => this.canvas.remove(o));
      this.guidelineObjects = [];

      const show = document.getElementById("toggleGuides")?.checked || false;
      if (!show) return;

      // Determine if we're on mobile
      const small = window.matchMedia("(max-width: 640px)").matches;
      
      // Use mobile or desktop settings
      const guideMargin = small ? this.mobileGuideMargin : this.desktopGuideMargin;
      const guideCornerRadius = small ? this.mobileGuideCornerRadius : this.desktopGuideCornerRadius;

      // Compute the drawing bounds
      let left, top, wPx, hPx;
      if (this.clipPath) {
        const bounds = this.clipPath.getBoundingRect(true);

        // Apply inset margin (keep it non-negative)
        const m = Math.max(0, guideMargin || 0);
        left = bounds.left + m;
        top  = bounds.top  + m + (small ? 0.5 : 1); // Smaller offset on mobile
        wPx  = Math.max(0, bounds.width  - m * 2) - (small ? 1 : 1);
        hPx  = Math.max(0, bounds.height - m * 2) - (small ? 1.9 : 3);
      } else {
        const m = Math.max(0, guideMargin || 0);
        left = 0 + m;
        top  = 0 + m;
        wPx  = Math.max(0, this.canvas.width  - m * 2);
        hPx  = Math.max(0, this.canvas.height - m * 2);
      }

      // Rounded, dashed guide
      const rectGuide = new fabric.Rect({
        left,
        top,
        width: wPx,
        height: hPx,
        fill: "transparent",
        stroke: "#ec008c",
        strokeWidth: small ? 0.8 : 1, // Thinner stroke on mobile
        strokeDashArray: [6, 3],
        rx: guideCornerRadius || 0,
        ry: guideCornerRadius || 0,
        selectable: false,
        evented: false,
        strokeUniform: true,
      });

      this.canvas.add(rectGuide);
      this.guidelineObjects.push(rectGuide);

      // Keep guides on top
      this._bringGuidesToFront();
      this.canvas.requestRenderAll();
    }

    async renderBoardFromState(boardIndex) {
      const bs = state[boardIndex === 1 ? "front" : "back"] || {};
      const token = ++this._renderToken;
      this.canvas.clear();
      this.backgroundImage = null;
      this.qrCodeImage = null;
      this.guidelineObjects = [];
      await new Promise((resolve) => {
        this.drawClipPath();
        setTimeout(resolve, 100);
      });
      if (bs.imageUrl) {
        await new Promise((resolve) => {
          fabric.Image.fromURL(
            bs.imageUrl,
            (img) => {
              if (token !== this._renderToken) return resolve();
              this._placeImage(img, bs.imageTransform || null);
              resolve();
            },
            { crossOrigin: "anonymous" }
          );
        });
      }
      if (boardIndex === 1 && bs.qrCode === "Yes") {
        this.addQRCode();
        this.updateQRCodePlacement(bs.qrCodePlacement || "Top Left");
      }
      this.canvas.renderAll();
      this.updateFinishButtonState();
    }

    _exportBagPng(multiplier = 2) {
      if (!this.clipPath) {
        return this.canvas.toDataURL({ format: "png", multiplier });
      }
      const { left, top, width, height } = this.clipPath.getBoundingRect(true);
      return this.canvas.toDataURL({
        left,
        top,
        width,
        height,
        format: "png",
        multiplier,
      });
    }

    toggleGuidelines(visible) {
      if (!this.canvas) return;
      this.guidelineObjects.forEach((obj) => (obj.visible = visible));
      this.canvas.renderAll();
    }

    alignObjects(direction) {
      if (!this.canvas || (!this.clipPath && !this.hasContent())) return;
      const activeObjects = this.canvas.getActiveObjects();
      if (!activeObjects.length) return;
      let bounds;
      if (this.clipPath) {
        bounds = this.clipPath.getBoundingRect(true);
      } else {
        bounds = {
          left: 0,
          top: 0,
          width: this.canvas.width,
          height: this.canvas.height,
        };
      }
      if (activeObjects.length === 1) {
        activeObjects.forEach((obj) => {
          switch (direction) {
            case "left":
              obj.set({ left: bounds.left + obj.getScaledWidth() / 2 });
              break;
            case "centerH":
              obj.set({ left: bounds.left + bounds.width / 2 });
              break;
            case "right":
              obj.set({
                left: bounds.left + bounds.width - obj.getScaledWidth() / 2,
              });
              break;
            case "top":
              obj.set({ top: bounds.top + obj.getScaledHeight() / 2 });
              break;
            case "centerV":
              obj.set({ top: bounds.top + bounds.height / 2 });
              break;
            case "bottom":
              obj.set({
                top: bounds.top + bounds.height - obj.getScaledHeight() / 2,
              });
              break;
          }
          obj.setCoords();
        });
      } else {
        let minLeft = Infinity,
          maxRight = -Infinity,
          minTop = Infinity,
          maxBottom = -Infinity;
        let totalCenterX = 0,
          totalCenterY = 0;
        activeObjects.forEach((obj) => {
          const bound = obj.getBoundingRect(true);
          minLeft = Math.min(minLeft, bound.left);
          maxRight = Math.max(maxRight, bound.left + bound.width);
          minTop = Math.min(minTop, bound.top);
          maxBottom = Math.max(maxBottom, bound.top + bound.height);
          totalCenterX += bound.left + bound.width / 2;
          totalCenterY += bound.top + bound.height / 2;
        });
        const avgCenterX = totalCenterX / activeObjects.length;
        const avgCenterY = totalCenterY / activeObjects.length;
        activeObjects.forEach((obj) => {
          switch (direction) {
            case "left":
              obj.set({ left: minLeft + obj.getScaledWidth() / 2 });
              break;
            case "centerH":
              obj.set({ left: avgCenterX });
              break;
            case "right":
              obj.set({ left: maxRight - obj.getScaledWidth() / 2 });
              break;
            case "top":
              obj.set({ top: minTop + obj.getScaledHeight() / 2 });
              break;
            case "centerV":
              obj.set({ top: avgCenterY });
              break;
            case "bottom":
              obj.set({ top: maxBottom - obj.getScaledHeight() / 2 });
              break;
          }
          obj.setCoords();
        });
      }
      this.canvas.renderAll();
    }

    _placeImage(img, snap = null) {
      let clipCenter, clipW, clipH;
      if (this.clipPath) {
        clipCenter = this.clipPath.getCenterPoint();
        const bounds = this.clipPath.getBoundingRect(true);
        clipW = bounds.width;
        clipH = bounds.height;
      } else {
        clipCenter = new fabric.Point(
          this.canvas.getWidth() / 2,
          this.canvas.getHeight() / 2
        );
        clipW = this.canvas.getWidth();
        clipH = this.canvas.getHeight();
      }

      if (!snap) {
        const scaleX = clipW / img.width;
        const scaleY = clipH / img.height;
        const scale = Math.min(scaleX, scaleY);
        img.set({
          scaleX: scale,
          scaleY: scale,
          originX: "center",
          originY: "center",
          left: clipCenter.x,
          top: clipCenter.y,
        });
      } else {
        img.set({ originX: "center", originY: "center" });
      }

      img.set({
        selectable: true,
        evented: true,
        hasControls: true,
        hasBorders: true,
        clipPath: null,
      });
      img.setCoords();

      if (this.backgroundImage) this.canvas.remove(this.backgroundImage);
      this.canvas.add(img);
      this.backgroundImage = img;

      if (snap) this._applySnapshot(img, snap);
      this.canvas.sendToBack(this.backgroundImage);
      if (this.qrCodeImage) this.canvas.bringToFront(this.qrCodeImage);
      this.canvas.renderAll();
      this.updateFinishButtonState();
    }

    addQRCode() {
      if (!this.canvas || state.currentBoard !== 1) {
        this.showError("QR code can only be added on the front board.");
        return;
      }
      if (this._qrLoading) {
        // A previous QR load is still in progress; don't start another
        return;
      }
      this._qrLoading = true;
      const callToken = ++this._qrToken;

      if (this.qrCodeImage) {
        this.canvas.remove(this.qrCodeImage);
        this.qrCodeImage = null;
      }
      state.front.qrCode = "Yes";
      fabric.Image.fromURL(
        this.qrCodeImageUrl,
        (img) => {
          if (callToken !== this._qrToken) { this._qrLoading = false; return; }
          if (!img) {
            console.error(
              "Failed to load QR code image from:",
              this.qrCodeImageUrl
            );
            this.showError(
              "Failed to load QR code image. Check the URL or network."
            );
            this._qrLoading = false;
            return;
          }
          img.set({
            selectable: false,
            evented: false,
            hasControls: false,
            hasBorders: false,
            originX: "center",
            originY: "center",
          });
          let clipW, clipH;
          if (this.clipPath) {
            const bounds = this.clipPath.getBoundingRect(true);
            clipW = bounds.width;
            clipH = bounds.height;
          } else {
            clipW = this.canvas.getWidth();
            clipH = this.canvas.getHeight();
          }
          const scale = Math.min(
            (clipW * 0.2) / img.width,
            (clipH * 0.2) / img.height
          );
          img.set({ scaleX: scale, scaleY: scale });
          img.clipPath = null;
          this.canvas.add(img);
          this.qrCodeImage = img;
          this.updateQRCodePlacement(state.front.qrCodePlacement || "Top Left");
          this.canvas.bringToFront(this.qrCodeImage);
          this.canvas.setActiveObject(this.qrCodeImage);
          console.log(
            "QR Code added at:",
            img.left,
            img.top,
            "Canvas size:",
            this.canvas.width,
            this.canvas.height
          );
          this.canvas.renderAll();
          this.updateFinishButtonState();
          this._qrLoading = false;
        },
        {
          crossOrigin: "anonymous",
          onError: () => {
            console.error(
              "QR code image load error for URL:",
              this.qrCodeImageUrl
            );
            this.showError(
              "Failed to load QR code image due to a network or CORS issue."
            );
            this._qrLoading = false;
          },
        }
      );
    }

    async handleImageUpload(event, explicitBoardIdx = null) {
      const file = event.target.files?.[0];
      if (!file) return;
      const targetBoard = explicitBoardIdx ?? state.currentBoard;
      if (!this.canvas) return;

      const reader = new FileReader();
      reader.onload = async (e) => {
        const url = e.target.result;
        const bs = state[targetBoard === 1 ? "front" : "back"];
        bs.imageUrl = url;
        bs.image = file;

        // Wait until clipPath is present so a redraw can’t wipe the image right after
        await new Promise((resolve) => {
          const check = () => (this.clipPath ? resolve() : requestAnimationFrame(check));
          check();
        });

        const token = ++this._renderToken;
        fabric.Image.fromURL(
          url,
          (img) => {
            if (token !== this._renderToken) return;
            this._placeImage(img);
            bs.imageTransform = this._snapshotObj(this.backgroundImage);
            this.canvas.requestRenderAll();
          },
          { crossOrigin: "anonymous" }
        );
      };
      reader.readAsDataURL(file);
    }

    updateQRCode() {
      if (!this.canvas) return;
      if (this._qrLoading) return;

      if (this.qrCodeImage) {
        this.canvas.remove(this.qrCodeImage);
        this.qrCodeImage = null;
      }

      if (state.currentBoard !== 1 || state.front.qrCode !== "Yes") {
        this.canvas.renderAll();
        return;
      }

      this._qrLoading = true;
      const callToken = ++this._qrToken;

      const qrUrl = this.qrCodeImageUrl;
      fabric.Image.fromURL(
        qrUrl,
        (img) => {
          if (callToken !== this._qrToken) { this._qrLoading = false; return; }
          if (!img) return;

          img.set({
            selectable: true,
            evented: true,
            hasControls: true,
            hasBorders: true,
            originX: "center",
            originY: "center",
          });

          let clipW, clipH;
          if (this.clipPath) {
            const bounds = this.clipPath.getBoundingRect(true);
            clipW = bounds.width;
            clipH = bounds.height;
            img.set({
              left: bounds.left + clipW / 2,
              top: bounds.top + clipH / 2,
            });
          } else {
            clipW = this.canvas.getWidth();
            clipH = this.canvas.getHeight();
            img.set({
              left: this.canvas.getWidth() / 2,
              top: this.canvas.getHeight() / 2,
            });
          }

          const scale = Math.min(
            (clipW * 0.2) / img.width,
            (clipH * 0.2) / img.height
          );
          img.set({ scaleX: scale, scaleY: scale });

          this.canvas.add(img);
          this.qrCodeImage = img;

          // Place it in selected corner
          this.updateQRCodePlacement(
            state.front.qrCodePlacement || "Bottom Right"
          );

          this.canvas.bringToFront(this.qrCodeImage);
          this.canvas.renderAll();
          this._qrLoading = false;
        },
        { crossOrigin: "anonymous" }
      );
    }

    updateQRCodePlacement(placement) {
      if (state.currentBoard !== 1 || !this.clipPath) return;

      // If QR code is enabled but qrCodeImage is null and placement is not "NONE", re-add the QR code
      if (
        state.front.qrCode === "Yes" &&
        !this.qrCodeImage &&
        placement !== "NONE"
      ) {
        this.addQRCode();
      }

      // If qrCodeImage still doesn't exist (e.g., addQRCode failed or placement is "NONE"), handle accordingly
      if (!this.qrCodeImage) {
        if (placement === "NONE") {
          this.canvas.renderAll();
          this.updateFinishButtonState();
        }
        return;
      }

      const bounds = this.clipPath.getBoundingRect(true);
      const isMobile = window.matchMedia("(max-width: 640px)").matches;
      const margin = isMobile ? this.qrMargins.mobile : this.qrMargins.desktop;
      const qrW = this.qrCodeImage.getScaledWidth();
      const qrH = this.qrCodeImage.getScaledHeight();

      let left, top;

      switch (placement) {
        case "Top Left":
          left = bounds.left + margin + qrW / 2;
          top = bounds.top + margin + qrH / 2;
          break;

        case "Top Right":
          left = bounds.left + bounds.width - margin - qrW / 2;
          top = bounds.top + margin + qrH / 2;
          break;

        case "Bottom Left":
          left = bounds.left + margin + qrW / 2;
          top = bounds.top + bounds.height - margin - qrH / 2;
          break;

        case "Bottom Right":
          left = bounds.left + bounds.width - margin - qrW / 2;
          top = bounds.top + bounds.height - margin - qrH / 2;
          break;

        case "NONE":
          this.canvas.remove(this.qrCodeImage);
          this.qrCodeImage = null;
          this.canvas.renderAll();
          this.updateFinishButtonState();
          return;

        default:
          // fallback: center
          left = bounds.left + bounds.width / 2;
          top = bounds.top + bounds.height / 2;
          break;
      }

      this.qrCodeImage.set({
        left,
        top,
        originX: "center",
        originY: "center",
      });
      this.qrCodeImage.setCoords();
      this.canvas.bringToFront(this.qrCodeImage);
      this.canvas.renderAll();
      this.updateFinishButtonState();

      console.log(`QR placed at ${placement}:`, { left, top, bounds });
    }
    
    updateBagColor(color) {
      if (!this.canvas) return;
      
      const boardState = state[state.currentBoard === 1 ? "front" : "back"];
      boardState.bagColor = color;
      
      // If we already have a clipPath (frame), just update it
      if (this.clipPath) {
          const currentColor = state.front.bagColor || "No Bag";
          const frameUrl = this.frameImages[currentColor];
          
          if (!frameUrl) {
              // If no frame URL, remove the current clipPath
              this.canvas.remove(this.clipPath);
              this.clipPath = null;
              this.canvas.renderAll();
              this.updateFinishButtonState();
              return;
          }
          
          // Store current objects and their positions
          const currentObjects = this.canvas.getObjects().filter(obj => 
              obj !== this.clipPath && 
              obj !== this.backgroundImage && 
              obj !== this.qrCodeImage &&
              !this.guidelineObjects.includes(obj)
          );
          
          // Store current transformations
          const objectSnapshots = currentObjects.map(obj => ({
              obj,
              snapshot: this._snapshotObj(obj)
          }));
          
          // Remove current frame
          this.canvas.remove(this.clipPath);
          
          // Load and add new frame
          fabric.Image.fromURL(
              frameUrl,
              (newFrameImg) => {
                  // Apply the same dimensions and position as the old frame
                  const oldBounds = this.clipPath ? this.clipPath.getBoundingRect(true) : {
                      left: 0,
                      top: 0,
                      width: this.canvas.getWidth(),
                      height: this.canvas.getHeight()
                  };
                  
                  const scaleX = oldBounds.width / newFrameImg.width;
                  const scaleY = oldBounds.height / newFrameImg.height;
                  
                  newFrameImg.set({
                      left: oldBounds.left,
                      top: oldBounds.top,
                      scaleX,
                      scaleY,
                      originX: "left",
                      originY: "top",
                      selectable: false,
                      evented: false,
                  });
                  
                  this.clipPath = newFrameImg;
                  this.canvas.add(this.clipPath);
                  
                  // Re-apply object transformations
                  objectSnapshots.forEach(({ obj, snapshot }) => {
                      this.canvas.add(obj);
                      if (snapshot) {
                          this._applySnapshot(obj, snapshot);
                      }
                  });
                  
                  // Ensure proper z-order
                  if (this.backgroundImage) this.canvas.sendToBack(this.backgroundImage);
                  if (this.qrCodeImage) this.canvas.bringToFront(this.qrCodeImage);
                  
                  this.canvas.renderAll();
                  this.updateFinishButtonState();
              },
              { crossOrigin: "anonymous" }
          );
      } else {
        // If no clipPath exists, create one normally
        this.drawClipPath();
      }
    }

    async finishEditing() {
      const originalBoard = state.currentBoard;
      try {
        if (!this.canvas) {
          throw new Error("Canvas not initialized");
        }
        // Check if QR code is enabled but link is empty
        if (state.front.qrCode === "Yes" && (!state.front.qrCodeLink.trim())) {
          const QRCodeLinkError = document.getElementById("qr-code-link-error-bar-b1");
          if (QRCodeLinkError) {
            QRCodeLinkError.style.display = "block";
            // Switch to Board 1 to show the QR code section
            if (state.currentBoard !== 1) {
              state.currentBoard = 1;
              // Update UI to show Board 1
              document.querySelectorAll(".board-tab").forEach((tab) => {
                const boardNum = parseInt(tab.dataset.board, 10);
                tab.classList.toggle("active", boardNum === 1);
              });
              document.getElementById("image-variant-b1").style.display = "";
              document.getElementById("variants-b1").style.display = "";
              document.getElementById("image-variant-b2").style.display = "none";
              document.getElementById("variants-b2").style.display = "none";
              // Re-render Board 1
              await this.renderBoardFromState(1);
            }
            // Scroll to the error message
            const scroller = this.findScrollableParent(QRCodeLinkError);
            if (scroller) {
              const rectTarget = QRCodeLinkError.getBoundingClientRect();
              const rectScroller = scroller.getBoundingClientRect();
              const offset = rectTarget.top - rectScroller.top;
              const centering = (scroller.clientHeight / 2) - (rectTarget.height / 2);
              const scrollToPos = scroller.scrollTop + offset - centering;
              scroller.scrollTo({ top: scrollToPos, behavior: 'smooth' });
            } else {
              QRCodeLinkError.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }
          return;
        }
        // ---------- Board 1 (always) ----------
        state.currentBoard = 1;
        await this.renderBoardFromState(1);
        await new Promise((resolve) => setTimeout(resolve, 300)); // Wait for rendering
        this.canvas.renderAll();
        // Hide guidelines before export
        this.guidelineObjects.forEach((g) => (g.visible = false));
        this.canvas.renderAll();
        // Ensure white background is present
        if (this.clipPath) {
          const { left, top, width, height } = this.clipPath.getBoundingRect(true);
          const whiteBg = new fabric.Rect({
            left,
            top,
            width,
            height,
            fill: "white",
            selectable: false,
            evented: false,
            originX: "left",
            originY: "top",
          });
          this.canvas.add(whiteBg);
          this.canvas.sendToBack(whiteBg); // Ensure white background is at the bottom
          this.canvas.renderAll();
        }
        const dataURL1 = this._exportBagPng();
        state.editedFront = this.dataURLtoFile(dataURL1, "front.png");
        const previewImage1 = document.getElementById("preview-image1");
        if (previewImage1) previewImage1.src = dataURL1;
        // ---------- Board 2 (only if customized and not same design) ----------
        const previewImage2 = document.getElementById("preview-image2");
        const preview2Wrap = document.querySelector(".bag-preview2");
        if (state.customizeBack && this.isBoardCustomized(state.back) && !state.sameDesignBack) {
          state.currentBoard = 2;
          await this.renderBoardFromState(2);
          await new Promise((resolve) => setTimeout(resolve, 300)); // Wait for rendering
          this.canvas.renderAll();
          // Hide guidelines before export
          this.guidelineObjects.forEach((g) => (g.visible = false));
          this.canvas.renderAll();
          // Ensure white background is present
          if (this.clipPath) {
            const { left, top, width, height } = this.clipPath.getBoundingRect(true);
            const whiteBg = new fabric.Rect({
              left,
              top,
              width,
              height,
              fill: "white",
              selectable: false,
              evented: false,
              originX: "left",
              originY: "top",
            });
            this.canvas.add(whiteBg);
            this.canvas.sendToBack(whiteBg); // Ensure white background is at the bottom
            this.canvas.renderAll();
          }
          const dataURL2 = this._exportBagPng();
          state.editedBack = this.dataURLtoFile(dataURL2, "back.png");
          if (previewImage2) previewImage2.src = dataURL2;
          if (preview2Wrap) preview2Wrap.style.display = "block";
        } else {
          state.editedBack = null;
          if (previewImage2) previewImage2.src = "";
          if (preview2Wrap) preview2Wrap.style.display = "none";
        }
        // Restore original board
        state.currentBoard = originalBoard;
        await this.renderBoardFromState(originalBoard);
        // UI updates
        const designerTool = document.getElementById("designerTool");
        const previewBox = document.getElementById("preview-box");
        const mainVariants = document.getElementById("main-variants");
        const uploadArtbox = document.getElementById("upload-artbox");
        const btnEditImage = document.getElementById("btnEditImage");
        if (designerTool) designerTool.classList.remove("active");
        this.enableBodyScroll();
        if (previewBox) previewBox.style.display = "block";
        if (mainVariants) mainVariants.classList.add("active");
        if (uploadArtbox) uploadArtbox.style.display = "none";
        if (btnEditImage) btnEditImage.style.display = "inline";
      } catch (err) {
        console.error("Error saving edited image:", err);
        this.showError("Failed to save edited image. Please try again.");
      } finally {
        // Restore guide visibility
        const toggleGuides = document.getElementById("toggleGuides");
        const shouldShowGuides = toggleGuides ? toggleGuides.checked : false;
        if (this.guidelineObjects.length > 0) {
          this.guidelineObjects.forEach((g) => (g.visible = shouldShowGuides));
          this.canvas.renderAll();
        }
      }
    }

    handleRemoveAllImproved() {
      if (this.canvas) {
        this.canvas.clear();
        this.clipPath = null;
        this.backgroundImage = null;
        this.qrCodeImage = null;
        this.guidelineObjects = [];
        this.drawClipPath();
        const boardState = state[state.currentBoard === 1 ? "front" : "back"];
        this.updateBagColor(boardState.bagColor || "No Bag");
        if (state.currentBoard === 1 && boardState.qrCode === "Yes") {
          this.updateQRCode(boardState.qrCodeLink);
          this.updateQRCodePlacement(boardState.qrCodePlacement);
        }
      }
    }

    showError(message) {
      const msgEl = document.getElementById("canvasMessage");
      if (msgEl) {
        msgEl.classList.remove("warning");
        msgEl.classList.add("error");
        msgEl.textContent = message;
        this.show(msgEl);
        setTimeout(() => this.hide(msgEl), 5000);
      }
    }

    showWarning(message) {
      const msgEl = document.getElementById("canvasMessage");
      if (msgEl) {
        msgEl.classList.remove("error");
        msgEl.classList.add("warning");
        msgEl.textContent = message;
        this.show(msgEl);
        setTimeout(() => this.hide(msgEl), 5000);
      }
    }

    handleResize() {
      if (!this.canvas) return;
      this.updateCanvasSize();
      this.drawClipPath();
      this.canvas.renderAll();
    }

    debounce(func, delay) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => func(...args), delay);
      };
    }

    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    }

    isBoardCustomized(boardState) {
      return (
        boardState.image ||
        boardState.imageUrl ||
        (boardState.qrCode === "Yes" && boardState.qrCodeLink)
      );
    }

    disableBodyScroll() {
      const scrollY = window.scrollY;
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.dataset.scrollY = scrollY;
    }

    enableBodyScroll() {
      const scrollY = document.body.dataset.scrollY || 0;
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      window.scrollTo(0, parseInt(scrollY, 10));
      document.body.removeAttribute("data-scrollY");
    }

    findScrollableParent(el) {
      while (el) {
        const style = window.getComputedStyle(el);
        const overflow = style.overflow || style.overflowY;
        if (overflow === "auto" || overflow === "scroll") {
          if (el.scrollHeight > el.clientHeight) {
            return el;
          }
        }
        el = el.parentElement;
      }
      return document.documentElement;
    }

    show(el) {
      if (el) el.style.display = "";
    }

    hide(el) {
      if (el) el.style.display = "none";
    }
  }
  // =============================================
  // 18. INITIALIZE EVERYTHING
  // =============================================
  function initialize() {
    designer = new MylarBagDesigner();
    bindUploadForBoard(1);
    bindUploadForBoard(2);
    setupSizeSelection();
    setupQRCodeSelection();
    handleQRCodeLinkInput();
    setupQRCodePlacement();
    setupBagColorSelection();
    initDropdownDefaults();
    setupApippaAddToCart();
    setupSameDesignCheckbox();
    setupBoardSwitching();
    document.addEventListener("click", dropdownClickHandler);
    document.getElementById("image-variant-b2").style.display =
      state.customizeBack ? "" : "none";
    document.getElementById("variants-b2").style.display = state.customizeBack
      ? ""
      : "none";
    document.getElementById("image-variant-b1").style.display = "";
    document.getElementById("variants-b1").style.display = "";
    recalcPrice();
    loadCurrentBoardState();
  }

  initialize();
});
